<template>
  <modal name="eprint-dialog" :adaptive="true" :scrollable="true" height="auto" class="eprint-modal" @opened="onEprintDialogOpened">
    <div ref="eprintDialog" style="overflow-y: auto;">
      <div class="v--modal-close-top">
        <el-button @click="closeDialog" icon="el-icon-circle-close" class="eprint-modal__close-btn" type="text"></el-button>
      </div>
      <div id="print-modal" class="setting" v-if="eprintResultCode == '100' && $firebase.isAuthenticated">
        <!-- PayPay決済確認中・クレジットカード決済処理中・コンビニプリント処理中・返金処理中のローディング表示 -->
        <div
          v-if="isPaypayProcessing || isEprintProcessing || isCreditCardProcessing || eprintPDFSending || isRefundProcessing"
          class="loading-overlay">
          <div class="loading-content">
            <div class="loading-spinner"></div>
            <p v-if="isPaypayProcessing" style="margin-top: 15px; font-weight: bold;">PayPay決済を確認中です...</p>
            <p v-if="isCreditCardProcessing" style="margin-top: 15px; font-weight: bold;">クレジットカード決済を処理中です...</p>
            <!-- <p v-if="isEprintProcessing" style="margin-top: 15px; font-weight: bold;">コンビニプリント番号を発行中です...</p> -->
            <p v-if="eprintPDFSending" style="margin-top: 15px; font-weight: bold;">コンビニプリント番号を発行中です...</p>
            <p v-if="isRefundProcessing" style="margin-top: 15px; font-weight: bold;">返金処理を実行中です...</p>
          </div>
        </div>

        <!--コンビニ印刷選択ポップアップ-->
        <div class="setting-item setting-item-eprint"
          :style="{ opacity: (isPaypayProcessing || isEprintProcessing || isCreditCardProcessing || eprintPDFSending || isRefundProcessing) ? 0.3 : 1 }">

          <div ref="sectionPrintType" class="print-price">
            <!-- おすすめオプション -->
            <div v-if="hasRecommendedOption" class="default">
              <p class="default_tag_txt">
                <span class="default_tag">おすすめ</span> {{ currentTemplateConfig.recommendedText }}
              </p>

              <div class="default_block">
                <el-radio v-model="printType" :label="recommendedOption.id" :class="getOptionClass(recommendedOption)" :style="selectedStyle(recommendedOption.id)" @click.native="handlePrintTypeChange(recommendedOption.id)">
                  <span class="el-radio__label">{{ getOptionLabel(recommendedOption) }}</span>
                  <span v-if="isCashlessSupported(recommendedOption)" class="cashless_tag" aria-label="キャッシュレス決済対応" title="キャッシュレス決済（クレカ・PayPay・Apple Pay）が利用できます">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                      <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/>
                    </svg>
                    <img src="/static/renew2_img/paypay_p_mark.png" class="paypay_mark" alt="PayPay" aria-hidden="true">
                  </span>
                  <span class="flex eprint_flex">
                    <span class="eprint_left">
                      <span class="price_tag">{{ recommendedOption.size }}</span>
                      <span class="price_tag">{{ recommendedOption.count }}</span>
                    </span>
                    <span class="eprint_right price">{{ eprintPrice }}<span class="price-small">円(税込)／{{
                      recommendedOption.count }}</span></span>
                  </span>
                  <span v-if="!isPrePayment" class="price-memo_seven">{{ getSevenElevenPriceMemo(recommendedOption)
                    }}</span>
                </el-radio>
              </div>
            </div>

            <!-- その他のオプション -->
            <el-collapse v-if="hasOtherOptions" v-model="otherSizesCollapse" class="default_block default_block--list other-sizes-collapse" @change="handleOtherSizesToggle">
              <el-collapse-item title="他のサイズ・決済方法もお選びいただけます" name="otherSizes">
              <div
                :class="printFlag === 'nophotolong' || printFlag === 'letter' || printFlag === 'taishokutodoke' || printFlag === 'keireki' ? 'list-flex' : ''">
                <div v-for="option in otherOptions" :key="option.id"
                  :class="printFlag === 'basic' ? 'list_block' : 'list_block'">
                  <el-radio v-model="printType" :label="option.id" :class="getOptionClass(option)" :style="selectedStyle(option.id)" @click.native="handlePrintTypeChange(option.id)">
                    <span class="el-radio__label">{{ getOptionLabel(option) }}</span>
                    <span v-if="isCashlessSupported(option)" class="cashless_tag" aria-label="キャッシュレス決済対応" title="キャッシュレス決済（クレカ・PayPay・Apple Pay）が利用できます">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                        <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/>
                      </svg>
                      <img src="/static/renew2_img/paypay_p_mark.png" class="paypay_mark" alt="PayPay" aria-hidden="true">
                    </span>
                    <span class="flex eprint_flex">
                      <span class="eprint_left">
                        <span class="price_tag">{{ option.size }}</span>
                        <span class="price_tag">{{ option.count }}</span>
                      </span>
                      <span class="eprint_right price">{{ eprintPrice }}<span class="price-small">円(税込)／{{ option.count
                          }}</span></span>
                    </span>
                    <span v-if="!isPrePayment" class="price-memo_seven">{{ getSevenElevenPriceMemo(option) }}</span>
                  </el-radio>
                </div>
              </div>
              </el-collapse-item>
            </el-collapse>
          </div>

          <!--規約-->
          <div ref="sectionTerms" class="term eprint-term">
            <p class="eprint-term__link">
              <router-link :to="{ name: 'eprintTerms' }" target="_blank" rel="noopener" class="external-link" @click.native="handleTermsLinkClick">コンビニ印刷の利用規約</router-link>
            </p>
          </div>

          <!--決済-->
          <div ref="sectionPayment" class="eprint-payment">

            <!--課金フォーム-->
            <div class="eprint-payment__form">
              <small-payment-method-selector ref="small-payment-method-selector" :serviceName="'コンビニプリント'"
                :price="currentPaymentPrice" :is_subscription="false" :is_simultaneous="false"
                @request-seven-eleven-payment="handleSevenElevenClick" @payment-success="handlePaymentSuccess"
                @paypay-payment="handlePaypayPayment" @credit-card-payment-start="handleCreditCardPaymentStart"
                @payment-error="handlePaymentError" :payment_method_used="'credit_card'" :print_type="printType"
                :default_payment_method="defaultEprintPaymentMethod" :format_id="formatid" />
            </div>
          </div>

          <!-- <div class="attention-logged-in">
              <el-button id="pdf-eprint-contents-code" type="success" class="print-btn" :disabled="!$deviceLib.isOnline"
                v-loading.fullscreen.lock="!eprintPdfEnabled"
                @click="$eventHub.$emit('eprint-renew2-PDF2'); eprintPdfEnabled = false; closeDialog; scrollToTop">
                <i class="el-icon-printer"></i> 利用規約に同意して印刷する
              </el-button>
            </div> -->

          <div class="print_memo">
            <p class="print_memo01">※コンビニ印刷の<a href="https://www.e-printservice.net/shohin/yagish" id="footer-link-eprint"
                target="_blank" rel="nofollow" class="external-link">詳しい利用方法を確認する</a></p>
            <p class="print_memo01">
              ※OSが古い場合など、レイアウトが崩れる場合があります。また、3ページ目入ると、コンビニ印刷には対応しておりません。プレビューで内容をご確認のうえ、ご購入ください。</p>
            <!-- <p class="print_memo01">※コンビニプリントが値上げされました。<a rel="nofollow"
                href="https://www.yagish.jp/information/print20231013/" target="_blank">こちらのページ</a>より内容をご確認ください。</p> -->
            <p class="print_memo02">※ご不明点等ございましたら、<a rel="nofollow" href="/contact" target="_blank"
                class="print_memo02__link">こちらのフォーム</a>よりご連絡ください。</p>
          </div>
        </div>
      </div>
    </div>

    <!--コンテンツ番号発行ポップアップ-->
    <div class="setting" v-if="eprintResultCode != '100'">
      <div class="setting-item eprint-result">
        <h2 class="eprint_logo_block">
          <img src="/static/img/eprint/eprint-logo.png" class="eprint_logo">
        </h2>
        <p class="mb-20px">
          <span class="font-weight-bold">
            お近くのコンビニのマルチコピー機にQRコード（二次元コード）をかざすと、書類がプリントできます。
          </span>
          eプリントサービスにて下記のコンテンツ番号を入力しても、決済・印刷することができます。
        </p>

        <div class="convenience-store-tabs">
          <div v-if="!isPrePayment" class="store-tabs">
            <el-button :class="['tab-button', { active: selectedStore === 'seven' }]"
              @click="isQRCodeLoaded = false; qrCodeError = false; qrCodeRetryCount = 0; selectedStore = 'seven'">
              セブンイレブン
            </el-button>
            <el-button :class="['tab-button', { active: selectedStore === 'others' }]"
              @click="isQRCodeLoaded = false; qrCodeError = false; qrCodeRetryCount = 0; selectedStore = 'others'">
              ファミリーマート・ローソン・ミニストップ・ポプラ
            </el-button>
          </div>

          <div class="qrcode-content">
            <!-- QRコード読み込み中のローディング表示 -->
            <div v-if="!isQRCodeLoaded && !qrCodeError" class="qrcode-loading">
              <div class="qrcode-spinner"></div>
              <p>QRコードを読み込み中...</p>
            </div>

            <!-- QRコード読み込みエラー表示 -->
            <div v-if="qrCodeError" class="qrcode-error">
              <p>読み込みに失敗しました</p>
              <el-button type="text" @click="retryQRCode">再読み込み</el-button>
            </div>

            <!-- 事前決済時: 自動的にローソン・ファミマなどのQRコードを表示 -->
            <div v-if="isPrePayment" class="qrcode-container">
              <h3>ファミリーマート・ローソン・ミニストップ・ポプラ</h3>
              <img v-show="isQRCodeLoaded && !qrCodeError" class="eprint_qrcode" :src="qrCodeImageSrc"
                @load="onQRCodeLoad" @error="onQRCodeError">
            </div>

            <!-- 事後決済時: タブ選択に応じてQRコードを表示 -->
            <div v-else :class="{ 'qrcode-container': selectedStore, 'qrcode-message': !selectedStore }">
              <img v-show="isQRCodeLoaded && !qrCodeError" class="eprint_qrcode" :class="{ 'sample': !selectedStore }"
                :src="qrCodeImageSrc" @load="onQRCodeLoad" @error="onQRCodeError">
            </div>
          </div>
        </div>

        <div class="printservice_block">
          <p class="printservice_number">コンテンツ番号：{{ eprintContentsCode }}</p>
          <p class="printservice_center">有効期限：{{ expirationDate }}まで</p>
        </div>

        <p style="margin: 30px 0;font-size: 14px;">アカウントのメールアドレスにコンテンツ番号とQRコードをお送りしました。お確かめの上、コンビニにて印刷してください。</p>

        <div class="print-section">
          <h2 class="print-heading">
            今すぐお手元に。近くの印刷スポットを確認
          </h2>

          <div class="print-map-area">
            <div v-show="showMap" ref="konbiniMap" class="print-map-img" style="height:250px;"></div>
            <img v-show="!showMap" src="https://placehold.jp/24/cccccc/ffffff/400x250.png?text=Map+Image" alt="Map"
              class="print-map-img" />
            <button type="button" class="print-map-btn" aria-label="現在地" @click="recenterToCurrentLocation"
              :disabled="isGeolocating">
              <span class="print-map-btn-icon"></span>
            </button>
          </div>

          <p v-if="mapError" class="konbini-map-error">{{ mapError }}</p>

          <div class="print-action-group">
            <a href="#" class="print-btn print-btn--large" @click.prevent="openMapAppNearCurrentLocation">
              <span class="print-btn-text">{{ isGeolocating ? '位置情報を取得中...' : '現在地周辺のコンビニをマップアプリで確認' }}</span>
              <span class="print-btn-icon-wrapper">
                <img src="/static/img/eprint/map-icon.svg" class="print-btn-icon-inner">
              </span>
            </a>

            <a v-if="resumeAddress" href="#" class="print-btn print-btn--small" @click.prevent="openMapAppNearResumeAddress">
              <span class="print-btn-text">{{ isGeocodingAddress ? '住所を検索中...' : '履歴書の住所周辺のコンビニを探す' }}</span>
              <span class="print-btn-icon-wrapper">
                <img src="/static/img/eprint/map-icon.svg" class="print-btn-icon-inner">
              </span>
            </a>
          </div>
        </div>

        <el-collapse v-model="downloadActiveCollapses">
          <el-collapse-item title="※利用時の注意事項" name="backup">
            <div class="el-collapse-item__content">
              <ul class="collapse-list">
                <li>有効期限が過ぎた場合やコンテンツ番号を忘れた場合は再度コンビニ印刷を行ってください。</li>
                <li>
                  ローソン・ファミリーマート以外のコンビニについては、10分程お時間がかかります。「販売終了もしくは、商品番号の入力が誤っている可能性があります。商品番号をご確認してください。」が表示された場合、少し時間を空けて再度ご入力をお試しください。
                </li>
              </ul>
            </div>
          </el-collapse-item>
        </el-collapse>
        <div class="printservice_memo_block">
          <a href="https://www.e-printservice.net/shohin/yagish" id="footer-link-eprint" target="_blank" rel="nofollow"
            class="external-link printservice_memo">※コンテンツ番号の利用方法を確認する</a>
        </div>

        <!-- 決済方法変更ボタン（事後決済の場合のみ表示） -->
        <div v-if="!isPrePayment" class="payment-change-button-container">
          <el-button @click="changePaymentMethod" type="primary" class="payment-change-button">
            決済方法を変更する
          </el-button>
        </div>
      </div>
    </div>

    <div class="text-right">
      <el-button @click="closeDialog">閉じる</el-button>
    </div>
    <!-- PayPay決済注意モーダル -->
    <modal name="open_paypay_eprint_modal" :adaptive="true" :scrollable="true" height="auto">
      <div class="v--modal-close-top">
        <el-button @click="$modal.hide('open_paypay_eprint_modal');" icon="el-icon-close" type="text"></el-button>
      </div>
      <div class="title" style="text-align: center;color: rgb(231, 54, 0);">決済しただけでは注文は完了しません</div>
      <br>
      <span>注文を完了するにはPayPay決済画面の「ご利用中のサービスに戻る」ボタンを押下してください。</span>
      <div style="width: 100%"><img src="/static/renew2_img/paypay_alert_image_20240214.png" style="width: 100%"></div>
      <div class="text-center">
        <el-button type="primary" style="width: 100%;height:70px;"
          @click="openPayPayEprintSite">注意事項を理解し、決済サービスを開く</el-button>
      </div>
    </modal>
  </modal>

</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>

<style lang="scss" scoped>

.eprint-modal ::v-deep .v--modal {
  margin: 20px;
  padding: 20px;
  width: auto !important;
  max-width: 600px;
  border-radius: 8px;
}

// 右上の閉じるボタン（丸型アイコン）
.eprint-modal__close-btn {
  font-size: 2rem;
  padding: 0;
}

// このモーダル内の折りたたみヘッダーだけ左余白を無効化
.eprint-modal ::v-deep .el-collapse-item__header {
  padding-left: 0 !important;
}

// このモーダル内の折りたたみコンテンツの左右余白を無効化
.eprint-modal ::v-deep .el-collapse-item__content {
  padding: 0 !important;
}

// 左上のラベル（コンビニ印刷）
#print-modal .eprint-modal__tip {
  position: relative;
  top: -38px;
  display: inline-block;
  font-weight: 700;
  font-size: 10px;
  color: #fff;
  background: #FF8C00;
  padding: 3px 10px;
  border-radius: 30px;
  margin-bottom: 0;
}

#print-modal .setting-item {
  padding: 0px;
  margin: 0px;
}

#print-modal .default_tag_txt {
  font-size: 12px;
  font-weight: bold;
  color: #E3165C;
  margin-bottom: 5px;
}

#print-modal .default_tag {
  display: inline-block;
  background: #E3165C;
  border-radius: 25px;
  font-size: 10px;
  color: #fff;
  padding: 1px 15px;
}

#print-modal .cashless_tag {
  display: inline-flex;
  align-items: center;
  margin-left: 6px;
  vertical-align: middle;
  color: #2E7D32;
  line-height: 1;
  cursor: help;
}

#print-modal .cashless_tag svg {
  width: 18px;
  height: 18px;
  display: block;
}

#print-modal .cashless_tag .paypay_mark {
  width: 18px;
  height: 18px;
  margin-left: 4px;
  display: block;
}

#print-modal {

  .default_block {

    .eprint-list-radio {
      position: relative;
      width: 100%;
      padding: 10px;
      border: 2px solid #dfdfdf;
      border-radius: 10px;

      //&--checked {
      //  border: 2px solid #E3165C;
      //}

      &--color {
        &::after {
          position: absolute;
          content: "";
          background-image: url(/static/renew2_img/eprint_img/icon_color.png);
          background-position: center;
          background-repeat: no-repeat;
          background-size: contain;
          width: 20px;
          height: 5px;
          top: 8px;
          right: 10px;
        }
      }

      &--mono {
        &::after {
          position: absolute;
          content: "";
          background-image: url(/static/renew2_img/eprint_img/icon_mono.png);
          background-position: center;
          background-repeat: no-repeat;
          background-size: contain;
          width: 20px;
          height: 5px;
          top: 8px;
          right: 10px;
        }
      }
    }

    .el-radio__label {
      padding: 0;
      font-weight: bold;
    }

    .eprint_flex {
      justify-content: space-between;
      align-items: end;
      margin: 5px 0;

      .eprint_left {

        .price_tag {
          color: #E95B10;
          border: 1px solid #E95B10;
          padding: 2px 8px;
          margin-right: 5px;
          border-radius: 30px;
          font-size: 12px;
          font-weight: bold;
        }
      }

      .price {
        color: #404040;
        font-size: 20px;
        font-weight: bold;

        .price-small {
          font-size: 14px;
          font-weight: normal;
        }
      }
    }

    .price-memo_seven {
      font-size: 10px;
      color: #E3165C;
    }

    &--list {
      .list_title {
        font-size: 12px;
        margin-bottom: 5px;
      }

      .eprint-list-radio {
        margin-bottom: 5px;
      }
    }

    // 「他のサイズ」アコーディオン
    &.other-sizes-collapse {
      border-top: none;
      border-bottom: none;

      .el-collapse-item__header {
        height: auto;
        line-height: 1.6;
        padding: 5px 0;
        font-size: 12px;
        font-weight: bold;
        color: #404040;
        border-bottom: none;
      }

      .el-collapse-item__wrap {
        border-bottom: none;
      }

      .el-collapse-item__content {
        padding-bottom: 0;
      }
    }
  }

  .eprint-term {
    &__link {
      text-align: right;
      margin: 10px 0;
      font-size: 12px;
    }
  }

  .print_memo {

    .print_memo01 {
      font-size: 12px;
    }

    .print_memo02 {
      font-size: 12px;

      &__link {
        border-bottom: 1px solid #404040;
      }
    }

  }
}

/*#print-modal .default_block,
#print-modal .list_block {
  border: 2px solid #E3165C;
  border: 2px solid #DFDFDF;
  border-radius: 10px;
  margin-top: 5px;
  margin-bottom: 10px;
  padding: 15px;
}

#print-modal .default_block .el-radio,
#print-modal .list_block .el-radio {
  width: 100%;
}

#print-modal .default_block .el-radio__label {
  color: #E3166C;
  font-weight: bold;
  padding-left: 0;
}

#print-modal .list_block .el-radio__label {
  font-weight: bold;
  font-size: 0.9rem;
  padding-left: 0;
}

#print-modal .price_tag {
  color: #E95B10;
  font-weight: bold;
  font-size: 0.8rem;
  border: 1px solid #E95B10;
  border-radius: 30px;
  padding: 2px 10px;
  margin-left: 5px;
}

#print-modal .price_tag01 {
  display: inline-block;
  margin-left: 30px;
  margin-top: 5px;
}

#print-modal .price_block {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 10px;
}

#print-modal .price_block img,
#print-modal .list_block img {
  width: 50px;
  height: auto;
}

#print-modal .price_block .price_txt,
#print-modal .list_block .price_txt {
  padding-left: 20px;
  white-space: pre-wrap;
}

#print-modal .price {
  font-size: 1.2rem;
  font-weight: bold;
}

#print-modal .list_block .price {
  text-align: right;
}

#print-modal .price-small {
  font-size: 0.8rem;
  font-weight: normal;
}

#print-modal .price-memo_seven {
  color: #E3166C;
  font-size: 0.6rem;
  line-height: 1.5;
  margin-top: 10px;
}

#print-modal .list_title {
  font-weight: bold;
  font-size: 0.8rem;
}

#print-modal .list {
  margin-top: 15px;
}

#print-modal .list-flex {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

#print-modal .list_block {
  border-color: #DFDFDF;
  width: calc(100% /2 - 5px);
}

#print-modal .print-btn {
  display: block;
  margin: 0 auto;
  background: #E3165C;
  border-color: #E3165C;
  border-radius: 25px;
  font-weight: bold;
}

#print-modal .term h3 {
  border: none;
  margin-bottom: 0;
  color: #004D40;
  text-align: center;
}

#print-modal .term p,
#print-modal .term li {
  font-size: 0.8rem;
}

#print-modal .print_memo01 {
  color: #E3165C;
  font-size: 0.7rem;
}

#print-modal .print_memo02 {
  font-size: 0.7rem;
}*/
</style>

<style scoped>
.printservice_bold {
  font-weight: bold;
}

.printservice_center {
  text-align: center;
  margin-top: 0;
  border: none;
}

.printservice_p {
  font-size: 13px;
  margin: 15px;
}

.printservice_block {
  text-align: center;
  border: 2px solid #E3166C;
  border-top: 0;
  border-radius: 0 0 10px 10px;
  padding: 5px;
}

.printservice_number {
  font-variant-numeric: slashed-zero;
  font-weight: bold;
  font-size: 18px;
}

.printservice_memo_block {
  line-height: 48px;
  font-size: 13px;
  height: auto;
}

.printservice_memo {
  padding-left: 1.5rem;
}

.printservice_h2::before {
  display: none;
}

.eprint_qrcode {
  width: 180px;
}

.sample {
  opacity: 0.1;
}

.eprint_qrcode_block {
  text-align: center;
}

.eprint_logo {
  width: 200px;
}

.eprint_logo_block {
  padding-bottom: 0.25rem;
  margin-bottom: 15px;
}

.eprint_qrcode_title {
  font-size: 11px;
  font-weight: bold;
}

.eprint-result {
  margin-top: 0;
  padding-top: 0;
}

.convenience-store-tabs {
  text-align: center;
}

.store-tabs {
  display: flex;
  justify-content: center;
  border-radius: 4px;
  flex-wrap: wrap;
  gap: 2px;
}

.tab-button {
  flex: 1;
  border: none;
  background: none;
  color: #606266;
  cursor: pointer;
  position: relative;
  border-radius: 4px;
  transition: all 0.3s;
  font-weight: bold;
  border: 2px solid #E3166C;
  border-bottom: 0;
  border-radius: 10px 10px 0 0;
  margin: 0px;
  padding: 12px;
  min-width: 0;
  word-wrap: break-word;
  white-space: normal;
  line-height: 1.2;
  font-size: 14px;
}

@media (max-width: 768px) {
  .tab-button {
    font-size: 12px;
    padding: 8px 6px;
    min-height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .store-tabs {
    gap: 1px;
  }
}

.tab-button.active {
  background: #E3166C;
  color: #fff;
}

.qrcode-content {
  padding: 30px 20px;
  background: #fff;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: 2px solid #E3166C;
  border-top: 1px solid #E3166C;
}

.qrcode-message {
  position: relative;
  color: #606266;
  font-size: 1.1em;
}

.qrcode-message::after {
  position: absolute;
  content: "利用するコンビニを選ぶと\AQRコードが表示されます";
  font-weight: bold;
  text-align: center;
  white-space: pre;
  right: calc(50% - 95px);
  top: calc(50% - 25px);
}

.qrcode-container {
  text-align: center;
}

.qrcode-container h3 {
  margin-bottom: 20px;
  color: #303133;
  font-size: 1.1em;
}

.qrcode-container img {
  max-width: 180px;
  height: auto;
}

/* QRコード読み込み中ローディング表示 */
.qrcode-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 180px;
  color: #606266;
}

.qrcode-loading p {
  margin-top: 15px;
  font-size: 14px;
  font-weight: bold;
}

.qrcode-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #E3166C;
  border-radius: 50%;
  animation: qrcode-spin 1s linear infinite;
}

@keyframes qrcode-spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* QRコードエラー表示 */
.qrcode-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 180px;
  color: #F56C6C;
}

.qrcode-error p {
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: bold;
}

.eprint-payment__form {
  min-width: 270px;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  border-radius: 4px;
}

.loading-content {
  text-align: center;
  color: #303133;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 10px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

#print-modal {
  position: relative;
}

.payment-change-button-container {
  text-align: center;
  margin-top: 20px;
  padding: 20px 0;
  border-top: 1px solid #e4e7ed;
}

.payment-change-button {
  background: #e3165c;
  border-color: #e3165c;
  border-radius: 8px;
  font-weight: bold;
  font-size: 14px;
  color: #ffffff;
  padding: 12px 24px;
  min-width: 200px;
  transition: all 0.3s;
}

.payment-change-button:hover {
  background: #66b1ff;
  border-color: #66b1ff;
}

.payment-change-button:active {
  background: #3a8ee6;
  border-color: #3a8ee6;
}

/* マップ表示 */
.print-container {
  max-width: 100%;
  padding: 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.print-text-top {
  font-size: 14px;
  color: #333333;
  margin: 0 0 16px 0;
  line-height: 1.5;
}

.print-hr {
  border: none;
  border-top: 1px solid #eeeeee;
  margin: 16px 0;
}

.print-section {
  text-align: center;
  margin-bottom: 18px;
  border-top: 1px solid #ebeef5;
}

.print-heading {
  font-size: 14px;
  font-weight: bold;
}

/* マップエリア */
.print-map-area {
  position: relative;
  width: 100%;
  margin-bottom: 20px;
  border-radius: 12px;
  overflow: hidden;
  line-height: 0;
}

.print-map-img {
  width: 100%;
  height: auto;
  display: block;
}

.print-map-btn {
  position: absolute;
  right: 12px;
  bottom: 12px;
  width: 44px;
  height: 44px;
  background-color: #ffffff;
  border: none;
  border-radius: 50%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.print-map-btn-icon {
  width: 20px;
  height: 20px;
  border: 2px solid #666666;
  border-radius: 50%;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 6px;
    height: 6px;
    background-color: #666666;
    border-radius: 50%;
  }
}

/* 共通ボタンデザイン */
.print-action-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.print-btn {
  display: flex;
  align-items: center;
  text-decoration: none;
  border-radius: 100px;
  padding: 8px 10px;
  width: 100%;
  box-sizing: border-box;
  transition: opacity 0.2s;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
}

.print-btn--large {
  background-color: rgb(17, 163, 50);
}

.print-btn--small {
  background-color: rgb(0, 77, 67);
}

.print-btn-text {
  flex: 1;
  color: #ffffff;
  font-size: 13px;
  font-weight: bold;
  text-align: center;
}

.print-btn-icon-wrapper {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.konbini-map-error {
  color: #e6a23c;
  font-size: 12px;
  text-align: center;
  margin-top: 8px;
}
</style>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.eprint-payment {
  margin-top: 1rem;
}

.setting-item-eprint {
  border-top: none;
  position: relative;
  top: -20px;
}

.external-link {
  font-size: 12px;
}
</style>

<script>
import SmallPaymentMethodSelector from './Payment/SmallPaymentMethodSelector.vue'
import { convertBlobUrlsToBase64 } from '@/mixins/blob-utils'

export default {
  components: {
    SmallPaymentMethodSelector
  },
  data: function () {
    return {
      eprintPdfEnabled: true,
      resultname: '',
      isNotLetter: true,
      eprintResultCode: '100',
      eprintContentsCode: '',
      expirationDate: '',
      previewHtml: '',
      downloadActiveCollapses: [''],
      // 「他のサイズ」アコーディオンの開閉状態（デフォルト閉じ）
      otherSizesCollapse: [],
      printFlag: 'basic',
      currentFormat: {},
      totalCost: 0,
      clearLocalStorageConfirmVisible: false,
      loading: true,
      formatid: '',
      paperInfo: '',
      paperNumb: '1',
      paperNumb2: '3',
      printType: '12', // 初期値を基本のカラー片面A4 2枚に設定
      selFontStyle4DB: '',
      printTypeOptions: [
        {
          value: '2',
          label: '白黒両面(A4) ：1枚/300円(税込)'
        },
        {
          value: '4',
          label: '白黒片面(A3) ：1枚/300円(税込)'
        }
      ],
      // マップ関連
      resumeAddress: '',
      showMap: false,
      mapError: '',
      isGeolocating: false,
      isGeocodingAddress: false,
      googleMap: null,
      googleMapsLoaded: false,
      currentLocationMarker: null,
      placesService: null,
      storeMarkers: [],
      infoWindow: null,
      currentPosition: null,
      selectedStore: null,
      isQRCodeLoaded: true,
      qrCodeError: false,
      qrCodeRetryCount: 0,
      qrCodeCacheBuster: 0,
      isSevenElevenButtonDisabled: false,
      paypayEprintUrl: '',
      merchantPaymentId: '',
      isPaypayProcessing: false, // PayPay決済確認中のローディング状態
      isEprintProcessing: false, // コンビニプリント番号発行中のローディング状態
      isCreditCardProcessing: false, // クレジットカード決済処理中のローディング状態
      eprintPDFSending: false, // PDF送信中のローディング状態（事後決済用）
      // 決済処理がサーバ側で継続中の可能性がある状態（axiosタイムアウト・サーバのprocessing応答）。
      // trueの間は再購入による二重課金を防ぐため購入ボタンを再活性化しない
      eprintProcessingPending: false,
      isPrePayment: false, // 事前決済（クレカ、PayPay、Apple Pay）で決済されたかどうか
      isRefundProcessing: false, // 返金処理中のローディング状態
      lastPaymentData: null, // 最後の決済データ（返金処理用）
      // 統一価格
      eprintPrice: 450,
      // テンプレート設定
      templateConfigs: {
        basic: {
          recommended: '12',
          recommendedText: '証明写真もカラーでくっきり！',
          options: [
            { id: '12', type: 'color', side: '片面', size: 'A4', count: '2枚', isRecommended: true },
            { id: '8', type: 'color', side: '片面', size: 'B4', count: '1枚' },
            { id: '7', type: 'color', side: '片面', size: 'A3', count: '1枚' },
            { id: '10', type: 'mono', side: '片面', size: 'A4', count: '2枚' },
            { id: '2', type: 'mono', side: '両面', size: 'A4', count: '1枚' }
          ]
        },
        design002: {
          recommended: '12',
          recommendedText: '証明写真もカラーでくっきり！',
          options: [
            { id: '12', type: 'color', side: '片面', size: 'A4', count: '2枚', isRecommended: true },
            { id: '10', type: 'mono', side: '片面', size: 'A4', count: '2枚' }
          ]
        },
        onepage: {
          recommended: '6',
          options: [
            { id: '6', type: 'color', side: '片面', size: 'A4', count: '1枚', isRecommended: true }
          ]
        },
        nophotoshot: {
          recommended: '1',
          options: [
            { id: '1', type: 'mono', side: '片面', size: 'A4', count: '1枚', isRecommended: true }
          ]
        },
        shiboudoukisho: {
          recommended: '1',
          options: [
            { id: '1', type: 'mono', side: '片面', size: 'A4', count: '1枚', isRecommended: true }
          ]
        },
        nophotolong: {
          recommended: '10',
          options: [
            { id: '10', type: 'mono', side: '片面', size: 'A4', count: '2枚', isRecommended: true },
            { id: '2', type: 'mono', side: '両面', size: 'A4', count: '1枚' },
            { id: '4', type: 'mono', side: '片面', size: 'A3', count: '1枚' }
          ]
        },
        letter: {
          recommended: '13',
          options: [
            { id: '13', type: 'mono', side: '片面', size: 'A4', count: '最大2枚', isRecommended: true },
            { id: '1', type: 'mono', side: '片面', size: 'A4', count: '1枚' },
            { id: '9', type: 'mono', side: '片面', size: 'B4', count: '最大2枚' },
            { id: '15', type: 'mono', side: '片面', size: 'A3', count: '1枚' }
          ]
        },
        taishokutodoke: {
          recommended: '13',
          options: [
            { id: '13', type: 'mono', side: '片面', size: 'A4', count: '最大2枚', isRecommended: true },
            { id: '1', type: 'mono', side: '片面', size: 'A4', count: '1枚' },
            { id: '9', type: 'mono', side: '片面', size: 'B4', count: '最大2枚' },
            { id: '15', type: 'mono', side: '片面', size: 'A3', count: '1枚' }
          ]
        },
        keireki: {
          recommended: '11',
          options: [
            { id: '11', type: 'mono', side: '片面', size: 'A4', count: '最大8枚', isRecommended: true },
            { id: '9', type: 'mono', side: '片面', size: 'B4', count: '最大2枚' },
            { id: '3', type: 'mono', side: '両面', size: 'A4', count: '最大4枚' },
            { id: '5', type: 'mono', side: '両面', size: 'A3', count: '最大2枚' }
          ]
        }
      },
      // ファネル分析用
      funnelSessionId: null,
      dialogOpenedAt: null,
      // 印刷タイプ再クリック判定用（前回ユーザーがクリックしたID）
      previousClickedPrintType: null,
      // セクション到達トラッキング用
      sectionObserver: null,
      viewedSections: {},
      isMypage: false
    }
  },
  methods: {
    selectedStyle: function (id) {
      if (id === this.printType) {
        return 'border-color:#E3165C;'
      }
      return ''
    },
    // 印刷オプションの表示ラベルを取得
    getOptionLabel: function (option) {
      return option.type === 'color' ? 'カラー' + option.side : '白黒' + option.side
    },
    // 印刷オプションのCSSクラスを取得
    getOptionClass: function (option) {
      const baseClass = 'eprint-list-radio'
      const typeClass = option.type === 'color' ? 'eprint-list-radio--color' : 'eprint-list-radio--mono'
      return `${baseClass} ${typeClass}`
    },
    // キャッシュレス決済（クレカ/PayPay/Apple Pay）対応の印刷タイプか判定
    // SmallPaymentMethodSelector.vue の事前決済グループ表示条件と整合させる
    isCashlessSupported: function (option) {
      const cashlessTypes = ['1', '4', '6', '7', '8', '15']
      return !!option && cashlessTypes.includes(String(option.id))
    },
    // 印刷タイプのラジオがクリックされた時、お支払い方法セクションへスムーズスクロール
    // openDialog 内のプログラム初期化と区別するため、ダイアログオープン直後はスキップ
    // 既に選択済みの印刷タイプを再クリックした場合もスクロールが走るよう @click.native を使用
    handlePrintTypeChange: function (clickedId) {
      if (!this.dialogOpenedAt || (new Date() - this.dialogOpenedAt) < 500) {
        return
      }

      // ファネル分析: スクロール導線発火イベント
      // 印刷タイプ選択変更時の `print_type_select` (watch側) と組み合わせて、
      // 再クリック数 = scroll_to_payment 件数 - print_type_select 件数 で算出可能
      if (this.funnelSessionId) {
        const isRecheck = this.previousClickedPrintType !== null &&
          String(this.previousClickedPrintType) === String(clickedId)
        this.$gtm.sendEprintEvent('scroll_to_payment', {
          print_type: String(clickedId),
          is_cashless: this.isCashlessSupported({ id: clickedId }),
          is_recheck: isRecheck,
          format_id: this.formatid,
          funnel_session_id: this.funnelSessionId
        })
        this.previousClickedPrintType = clickedId
      }

      this.$nextTick(() => {
        const target = this.$refs.sectionPayment
        if (target && typeof target.scrollIntoView === 'function') {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      })
    },
    // ファネル分析: 「他のサイズ」折りたたみの開閉イベント送信
    handleOtherSizesToggle: function (activeNames) {
      if (!this.funnelSessionId) {
        return
      }
      this.$gtm.sendEprintEvent('other_sizes_toggle', {
        action: (activeNames && activeNames.length > 0) ? 'open' : 'close',
        print_type: String(this.printType),
        format_id: this.formatid,
        funnel_session_id: this.funnelSessionId
      })
    },
    // ファネル分析: 利用規約リンククリックイベント送信
    handleTermsLinkClick: function () {
      if (!this.funnelSessionId) {
        return
      }
      this.$gtm.sendEprintEvent('terms_link_click', {
        format_id: this.formatid,
        funnel_session_id: this.funnelSessionId
      })
    },
    // セブンイレブンの価格メモを取得
    getSevenElevenPriceMemo: function (option) {
      if (this.printFlag === 'nophotolong' || this.printFlag === 'letter' || this.printFlag === 'taishokutodoke' || this.printFlag === 'keireki' || this.printFlag === 'shiboudoukisho') {
        return '※セブンイレブンで印刷する場合は、500円になります。'
      }
      return '※セブンイレブンで印刷する場合は、700円になります。'
    },
    // QRコード読み込み成功時
    onQRCodeLoad: function () {
      this.isQRCodeLoaded = true
      this.qrCodeError = false
      this.qrCodeRetryCount = 0
    },
    // QRコード読み込みエラー時（自動リトライ付き）
    onQRCodeError: function () {
      this.qrCodeRetryCount++
      if (this.qrCodeRetryCount < 3) {
        // 2秒後に自動リトライ
        setTimeout(() => {
          this.forceReloadQRCode()
        }, 2000)
      } else {
        // 3回失敗したらエラー表示
        this.qrCodeError = true
        this.isQRCodeLoaded = true
      }
    },
    // QRコード手動リトライ
    retryQRCode: function () {
      this.qrCodeError = false
      this.isQRCodeLoaded = false
      this.qrCodeRetryCount = 0
      this.forceReloadQRCode()
    },
    convertBlobUrlsToBase64: function (html) {
      return convertBlobUrlsToBase64(html)
    },
    // QRコード強制再読み込み（キャッシュバスター更新）
    forceReloadQRCode: function () {
      this.qrCodeCacheBuster = Date.now()
      this.isQRCodeLoaded = false
    },
    openDialog: async function (id, html, selFontStyle4DB, resumeAddress, isMypage = false) {
      this.isMypage = isMypage
      this.resumeAddress = resumeAddress || ''
      console.log('=== EprintDialog.openDialog 開始 ===')
      console.log('id:', id)
      console.log('html:', html)
      console.log('selFontStyle4DB:', selFontStyle4DB)

      // 決済完了状態でない場合のみ状態をリセット
      // 決済完了後（eprintResultCode != '100'）の場合は、isPrePaymentの状態を保持
      if (this.eprintResultCode === '100') {
        this.isPrePayment = false
        this.selectedStore = null
      }

      // 決済処理継続中ロックはダイアログを開き直したタイミングで解除する。
      // 本当に処理が進行中なら、サーバ側の二重購入ガードが与信解放付きで再購入を弾くため安全
      if (this.eprintProcessingPending) {
        this.eprintProcessingPending = false
        this.isSevenElevenButtonDisabled = false
        const selector = this.$refs['small-payment-method-selector']
        if (selector) {
          selector.isConvinienceButtonDisabled = false
          selector.isCardButtonDisabled = false
          selector.isPaypayButtonDisabled = false
        }
      }

      // return
      if (html.$el) {
        this.previewHtml = html.$el.innerHTML
      } else {
        this.previewHtml = html.innerHTML
        id = 'shokumukeirekisho'
      }
      // YagiPrime背景透過画像: blob URLをbase64に変換（Puppeteerで解決可能にする）
      this.previewHtml = await this.convertBlobUrlsToBase64(this.previewHtml)
      this.formatid = id
      this.selFontStyle4DB = selFontStyle4DB
      if (id === 'rirekisho_single') {
        this.paperInfo = '片面'
        this.paperNumb = '1'
        this.paperNumb2 = '2'
        this.printType = '6'
        this.printFlag = 'onepage'
      } else if (id === 'rirekisho_arbeit_debut') {
        this.paperInfo = '片面'
        this.paperNumb = '1'
        this.paperNumb2 = '2'
        this.printType = '6'
        this.printFlag = 'onepage'
      } else if (id === 'rirekisho_nophoto') {
        this.paperInfo = '片面'
        this.paperNumb = '4'
        this.paperNumb2 = '2'
        this.printType = '1'
        this.printFlag = 'nophotoshot'
      } else if (id === 'rirekisho_nophoto_double') {
        this.paperInfo = '両面'
        this.paperNumb = '4'
        this.paperNumb2 = '3'
        this.printType = '2'
        this.printFlag = 'nophotolong'
      } else if (id === 'shokumukeirekisho') {
        this.paperInfo = '両面'
        this.paperNumb = '最大4'
        this.paperNumb2 = '9'
        this.printType = '11'
        this.printFlag = 'keireki'
      } else if (id.indexOf('shokumukeirekisho') >= 0) {
        this.paperInfo = '両面'
        this.paperNumb = '最大4'
        this.paperNumb2 = '9'
        this.printType = '11'
        this.printFlag = 'keireki'
      } else if (id === 'rirekisho_job_new_single') {
        this.paperInfo = '片面'
        this.paperNumb = '4'
        this.paperNumb2 = '8'
        this.printType = '6'
        this.printFlag = 'onepage'
      } else if (id === 'entrysheet') {
        this.paperInfo = '片面'
        this.paperNumb = '4'
        this.paperNumb2 = '8'
        this.printType = '6'
        this.printFlag = 'onepage'
      } else if (id === 'shiboudoukisho') {
        this.paperInfo = '片面'
        this.paperNumb = '1'
        this.paperNumb2 = '1'
        this.printType = '1'
        this.printFlag = 'shiboudoukisho'
      } else if (id === 'rirekisho_design_002') {
        this.paperInfo = '両面'
        this.paperNumb = '1'
        this.paperNumb2 = '3'
        this.printType = '12'
        this.printFlag = 'design002'
      } else if (id === 'english_resume') {
        this.paperInfo = '片面'
        this.paperNumb = '最大2'
        this.paperNumb2 = '5'
        this.printType = '12'
        this.printFlag = 'basic'
      } else {
        this.paperInfo = '両面'
        this.paperNumb = '1'
        this.paperNumb2 = '3'
        this.printType = '12'
        this.printFlag = 'basic'
      }
      console.log('$modal.show("eprint-dialog") を実行します')

      try {
        this.$modal.show('eprint-dialog')
        console.log('$modal.show("eprint-dialog") を実行しました - 成功')
      } catch (error) {
        console.error('$modal.show("eprint-dialog") でエラー発生:', error)
      }

      // モーダルの状態を確認
      this.$nextTick(() => {
        console.log('モーダル表示状態確認:')
        console.log('this.$modal:', this.$modal)

        // 異なる方法でモーダルの状態を確認
        try {
          // 1. DOM要素の確認
          const modalElement = document.querySelector('.v--modal[data-modal="eprint-dialog"]')
          console.log('DOM内のeprint-dialog要素:', modalElement)

          // 2. vue-js-modalのグローバル状態確認
          if (window.VModal) {
            console.log('VModal:', window.VModal)
          }

          // 3. Vue.$modalの詳細確認
          console.log('$modal keys:', Object.keys(this.$modal))
          for (const key in this.$modal) {
            if (typeof this.$modal[key] !== 'function') {
              console.log(`$modal.${key}:`, this.$modal[key])
            }
          }

          // 4. 直接モーダルコンポーネントの確認
          const eprintDialogModal = this.$children.find(child =>
            child.$options.name === 'Modal' ||
            child.$vnode.componentOptions.tag === 'modal'
          )
          console.log('EprintDialog内のModalコンポーネント:', eprintDialogModal)
        } catch (error) {
          console.error('モーダル状態確認エラー:', error)
        }
      })
      this.clearLocalStorageConfirmVisible = false
      if (this.formatid === 'letter' || this.formatid === 'taishokutodoke') {
        this.isNotLetter = false
        this.printType = '13'
        this.printFlag = 'letter'
      }
      const nowdate = new Date()
      const date1 = new Date('2023/06/06 01:00:00')
      const date2 = new Date('2023/06/06 02:00:00')
      if (nowdate > date1 && nowdate < date2) {
        this.eprintResultCode = 'maintenance'
      }

      // ファネル分析: ダイアログ表示イベント送信
      this.funnelSessionId = this.$gtm.generateFunnelSessionId()
      this.dialogOpenedAt = new Date()
      this.previousClickedPrintType = null
      const templateConfig = this.templateConfigs[this.printFlag] || this.templateConfigs.basic
      const cashlessOptionCount = templateConfig.options.filter(o => this.isCashlessSupported(o)).length
      this.$gtm.sendEprintEvent('dialog_open', {
        format_id: this.formatid,
        print_flag: this.printFlag,
        default_print_type: this.printType,
        default_is_cashless: this.isCashlessSupported({ id: this.printType }),
        cashless_option_count: cashlessOptionCount,
        total_option_count: templateConfig.options.length,
        // リリース跨ぎのキャッシュ混在期でも新旧UIを区別できるようにする
        ui_version: 'dialog_v2_collapse',
        funnel_session_id: this.funnelSessionId
      })

      // セクション到達トラッキング開始
      // setupSectionObserverはonEprintDialogOpened（モーダルopenedイベント）側で呼ぶ。
      // ここ（$modal.show直後のnextTick）ではモーダルのトランジションが完了しておらず、
      // IntersectionObserverの初期交差判定がレイアウト確定前に走ってしまう。
      this.viewedSections = {}
    },
    closeDialog: function () {
      // ファネル分析: ダイアログ閉じるイベント送信（離脱分析用）
      if (this.funnelSessionId) {
        const timeSpent = this.dialogOpenedAt
          ? Math.round((new Date() - this.dialogOpenedAt) / 1000)
          : 0
        this.$gtm.sendEprintEvent('dialog_close', {
          format_id: this.formatid,
          is_completed: this.eprintResultCode !== '100',
          last_print_type: this.printType,
          time_spent_seconds: timeSpent,
          funnel_session_id: this.funnelSessionId
        })
      }

      // セクション到達トラッキング停止
      this.teardownSectionObserver()

      this.$modal.hide('eprint-dialog')
      this.clearLocalStorageConfirmVisible = false
      this.$globalVar.dn_flag = 'eprint'
      this.$eventHub.$emit('display_rt_popup')
      // 注意: isPrePaymentやeprintResultCodeの状態は保持する
      // 決済完了後の状態を維持するため、ここではリセットしない
      this.cleanupMap()
    },
    changePaymentMethod: function () {
      console.log('決済方法変更ボタンがクリックされました')

      // 現在の決済セッションをリセット
      this.eprintResultCode = '100'
      this.isPrePayment = false
      this.selectedStore = null
      this.lastPaymentData = null
      this.cleanupMap()

      // PayPay決済の場合、クッキーもクリア
      if (this.$cookies.get('paypay_payment_history_id')) {
        this.$cookies.remove('paypay_payment_history_id')
        console.log('決済方法変更時、PayPay payment_history_idクッキーをクリア')
      }

      // 決済方法選択画面に戻る
      this.scrollToTop()

      console.log('決済方法選択画面に戻りました')
    },
    scrollToTop () {
      this.$nextTick(() => {
        // vue-js-modal は height:auto + scrollable のとき、内側の overflow:auto div ではなく
        // オーバーレイ(.v--modal-overlay)側がスクロールする。どの要素がスクロールするかに依存しないよう、
        // モーダル本体から祖先を辿って「実際にスクロールしている要素」を全て先頭へ戻す。
        const start = this.$refs.eprintDialog ||
          document.querySelector('.v--modal[data-modal="eprint-dialog"]')
        let el = start
        while (el && el !== document.body) {
          if (el.scrollHeight > el.clientHeight + 1) {
            if (typeof el.scrollTo === 'function') {
              el.scrollTo({ top: 0, behavior: 'smooth' })
            } else {
              el.scrollTop = 0
            }
          }
          el = el.parentElement
        }
        // 念のため window もページ先頭へ
        if (typeof window.scrollTo === 'function') {
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }
      })
    },
    // モーダルの表示・描画完了後に発火（vue-js-modal の opened イベント）。
    // PayPay 復帰時は eprintResultCode を '200' にしてからモーダルを開くため、
    // watcher 内の scrollToTop はモーダル未表示で空振りする。開ききった後の
    // ここで結果（QRコード）画面なら最上部へスクロールし直す。
    onEprintDialogOpened () {
      if (this.eprintResultCode !== '100') {
        this.scrollToTop()
      }
      // restoreEprintDialogFromPaypay等、openDialogを経由せず直接$modal.showする
      // 復帰経路ではfunnelSessionIdが未生成のため、その場合はセクション計測を開始しない。
      if (this.funnelSessionId) {
        this.setupSectionObserver()
      }
    },
    // --- セクション到達トラッキング ---
    setupSectionObserver () {
      this.teardownSectionObserver()
      const sections = {
        sectionPrintType: 'print_type',
        sectionTerms: 'terms',
        sectionPayment: 'payment_method'
      }

      // root指定なし（ビューポート基準）。vue-js-modalはheight:auto+scrollable時に
      // 内側のoverflow:auto divではなくオーバーレイ(.v--modal-overlay)側がスクロールするため、
      // root: this.$refs.eprintDialog を指定すると交差判定が機能しない（scrollToTop参照）。
      this.sectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return
          const sectionName = entry.target.dataset.trackSection
          if (!sectionName || this.viewedSections[sectionName]) return
          this.viewedSections[sectionName] = true
          this.$gtm.sendEprintEvent('section_view', {
            section: sectionName,
            format_id: this.formatid,
            print_type: this.printType,
            is_cashless_available: this.isCashlessSupported({ id: this.printType }),
            funnel_session_id: this.funnelSessionId
          })
        })
      }, { threshold: 0 })

      Object.entries(sections).forEach(([ref, name]) => {
        const el = this.$refs[ref]
        if (el) {
          el.dataset.trackSection = name
          this.sectionObserver.observe(el)
        }
      })
    },
    teardownSectionObserver () {
      if (this.sectionObserver) {
        this.sectionObserver.disconnect()
        this.sectionObserver = null
      }
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    eprintPDF2: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      this.eprintPDFSending = true
      const pdfStartTime = Date.now()

      // ファネル分析: PDF生成開始イベント
      this.$gtm.sendEprintEvent('pdf_generation_start', {
        payment_method: 'postpaid',
        print_type: this.printType,
        format_id: this.formatid,
        funnel_session_id: this.funnelSessionId
      })

      const formData = this.pdfFormData
      formData.append('filename', this.createFilename('pdf'))
      formData.append('format_id', this.formatid)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('print_type', this.printType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('app_flag', this.$site.appFlag)
      formData.append('font_name', this.selFontStyle4DB)
      formData.append('version', '2')
      formData.append('is_mypage', this.isMypage ? 'true' : 'false')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.pdfEprint, formData, { timeout: 60000 })
        .then(function (response) {
          if (response.data.result === 'success') {
            app.resultname = 'なし'
            app.eprintResultCode = '200'
            app.eprintContentsCode = response.data.contents_code
            app.expirationDate = response.data.expiration_date

            // ファネル分析: PDF生成完了イベント
            app.$gtm.sendEprintEvent('pdf_generation_complete', {
              payment_method: 'postpaid',
              duration_ms: Date.now() - pdfStartTime,
              print_type: app.printType,
              format_id: app.formatid,
              funnel_session_id: app.funnelSessionId
            })

            // ファネル分析: コンテンツ番号発行成功イベント（事後決済フロー）
            app.$gtm.sendEprintEvent('code_issued', {
              contents_code: response.data.contents_code,
              expiration_date: response.data.expiration_date,
              payment_method: 'postpaid',
              price: app.currentPaymentPrice,
              print_type: app.printType,
              format_id: app.formatid,
              funnel_session_id: app.funnelSessionId
            })
          } else {
            if (response.data.message === '不正なページ数です') {
              app.$message({
                duration: 0,
                showClose: true,
                dangerouslyUseHTMLString: true,
                message: `送信失敗しました。${response.data.message}<br><br>ふりがなが長すぎるなどの理由により、フォーマットが崩れている可能性があります。<br>入力内容を確認し、修正してください。<br>ブラウザのキャッシュを削除するか、更新してください。`,
                type: 'error'
              })
            } else if (response.data.message === 'バージョンエラーです。ブラウザのキャッシュを削除するか、更新してください。') {
              app.$message({
                duration: 0,
                showClose: true,
                dangerouslyUseHTMLString: true,
                message: `送信失敗しました。${response.data.message}<br><br>今見ている画面が古い可能性があります。<br>ブラウザのキャッシュを削除するか、更新してください。`,
                type: 'error'
              })
            } else {
              app.$message({
                duration: 0,
                showClose: true,
                message: `送信失敗しました。${response.data.message}`,
                type: 'error'
              })
            }
          }
        })
        .catch(function (error) {
          // ファネル分析: PDF生成エラーイベント
          app.$gtm.sendEprintEvent('pdf_generation_error', {
            error_message: String(error),
            payment_method: 'postpaid',
            duration_ms: Date.now() - pdfStartTime,
            print_type: app.printType,
            format_id: app.formatid,
            funnel_session_id: app.funnelSessionId
          })

          // ネットワークエラーやタイムアウトの場合、事前決済なら返金処理を実行
          if (app.isPrePayment && app.lastPaymentData) {
            console.log('コンビニプリント処理でネットワークエラー - 返金処理を開始します')
            app.handleEprintFailureRefund('技術的な問題によりコンテンツ番号が発行できませんでした')
            return
          }

          app.$message({
            duration: 0,
            showClose: true,
            message: '送信失敗しました。しばらくしてから再度お試しください',
            type: 'error'
          })
          console.error(error)
          app.$gtm.sendError('pdf eprint api', `send pdf eprint-api failed ${error}`)
        }).finally(function () {
          app.eprintPdfEnabled = true
          app.eprintPDFSending = false
          app.isSevenElevenButtonDisabled = false
          app.$refs['small-payment-method-selector'] && (app.$refs['small-payment-method-selector'].isConvinienceButtonDisabled = false)
        })
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      const LENGTH = 5
      const WORDS = 'abcdefghijklmnopqrstuvwxyz0123456789'
      let rString = ''
      for (let i = 0; i < LENGTH; i++) {
        rString += WORDS[Math.floor(Math.random() * WORDS.length)]
      }
      rString += '_'
      return `${prefix}${rString}${this.formatid}${dateString}.${ext}`
    },
    dataChanged: function () {
      this.eprintResultCode = '100'
      this.eprintPdfEnabled = true
    },
    handleSevenElevenClick: function () {
      this.isSevenElevenButtonDisabled = true
      this.$eventHub.$emit('eprint-renew2-PDF2')
      this.eprintPdfEnabled = false
      // this.closeDialog()
      this.scrollToTop()
    },
    handleCreditCardPaymentStart: function () {
      console.log('EprintDialog: クレジットカード決済開始')
      console.log('EprintDialog: isCreditCardProcessing を true に設定します')
      // クレジットカード決済処理中のローディング開始
      this.isCreditCardProcessing = true
      console.log('EprintDialog: isCreditCardProcessing =', this.isCreditCardProcessing)

      // ファネル分析: クレジットカード決済開始イベント送信
      this.$gtm.sendEprintEvent('credit_card_payment_start', {
        payment_method: 'stripe',
        price: this.currentPaymentPrice,
        print_type: this.printType,
        format_id: this.formatid,
        funnel_session_id: this.funnelSessionId
      })
    },
    handlePaymentSuccess: function (paymentData) {
      console.log('EprintDialog: 決済成功を受信', paymentData)
      // クレジットカード決済処理中のローディング終了
      this.isCreditCardProcessing = false
      // 事前決済フラグをセット
      this.isPrePayment = true

      // ファネル分析: 決済成功イベント送信
      this.$gtm.sendEprintEvent('payment_success', {
        payment_method: 'stripe',
        price: this.currentPaymentPrice,
        print_type: this.printType,
        format_id: this.formatid,
        transaction_id: (paymentData && paymentData.paymentHistoryId) || null,
        funnel_session_id: this.funnelSessionId
      })
      // GA4 Eコマースイベント送信
      this.$gtm.sendEprintPurchase({
        transaction_id: 'eprint_stripe_' + ((paymentData && paymentData.paymentHistoryId) || Date.now()),
        value: this.currentPaymentPrice,
        print_type: this.printType,
        product_name: this.$gtm.getPrintTypeLabel(this.printType)
      })

      // CardPaymentで既に決済ログが保存されているので、そのpayment_history_idを使用
      if (paymentData && paymentData.paymentHistoryId) {
        console.log('CardPaymentで保存された決済ログを使用:', paymentData.paymentHistoryId)
        // 決済データを保存（返金処理用）
        this.lastPaymentData = {
          paymentType: 'stripe',
          paymentCost: this.currentPaymentPrice,
          printType: this.printType,
          formatId: this.formatid,
          paymentHistoryId: paymentData.paymentHistoryId,
          stripePaymentIntentId: paymentData.paymentIntentId,
          stripeChargeId: paymentData.chargeId,
          timestamp: new Date().toISOString()
        }
      } else {
        console.warn('CardPaymentからpayment_history_idが取得できませんでした。フォールバック処理を実行します。')
        // フォールバック：EprintDialogで決済ログを保存
        const stripeDetail = JSON.stringify({
          payment_intent_id: paymentData ? paymentData.paymentIntentId : null,
          charge_id: paymentData ? paymentData.chargeId : null,
          timestamp: new Date().toISOString()
        })

        this.savePaymentLogAndGetId('stripe', this.currentPaymentPrice, true, stripeDetail)
          .then((paymentHistoryId) => {
            this.lastPaymentData = {
              paymentType: 'stripe',
              paymentCost: this.currentPaymentPrice,
              printType: this.printType,
              formatId: this.formatid,
              paymentHistoryId,
              stripePaymentIntentId: paymentData ? paymentData.paymentIntentId : null,
              stripeChargeId: paymentData ? paymentData.chargeId : null,
              timestamp: new Date().toISOString()
            }
          })
          .catch((error) => {
            console.error('決済ログ保存エラー:', error)
            this.lastPaymentData = {
              paymentType: 'stripe',
              paymentCost: this.currentPaymentPrice,
              printType: this.printType,
              formatId: this.formatid,
              stripePaymentIntentId: paymentData ? paymentData.paymentIntentId : null,
              stripeChargeId: paymentData ? paymentData.chargeId : null,
              timestamp: new Date().toISOString()
            }
          })
      }

      // this.eprintPDF2()
      // paymentData を直接渡す: authorize+capture 分離で payment_intent_id を確実に番号発行APIへ渡すため
      // （フォールバック経路では lastPaymentData の設定が非同期で間に合わないことがあるため、引数を優先する）
      this.eprintAtokakin(paymentData)
    },
    handlePaymentError: function (error) {
      console.log('EprintDialog: 決済エラーを受信', error)

      // ファネル分析: 決済エラーイベント送信
      this.$gtm.sendEprintEvent('payment_error', {
        payment_method: 'stripe',
        price: this.currentPaymentPrice,
        print_type: this.printType,
        format_id: this.formatid,
        error_message: (error && error.message) || '不明なエラー',
        error_code: (error && error.code) || 'unknown',
        funnel_session_id: this.funnelSessionId
      })

      // エラーメッセージを取得（具体的なエラーメッセージがある場合はそれを使用）
      let errorMessage = '決済に失敗しました。'
      if (error && error.message) {
        errorMessage = error.message
      }

      // エラーメッセージをトーストで表示
      this.$message({
        message: errorMessage,
        type: 'error'
      })

      // クレジットカード決済処理中のローディング終了
      this.isCreditCardProcessing = false
    },
    handlePaypayPayment: function () {
      console.log('EprintDialog: PayPay決済開始')

      // ファネル分析: PayPay決済開始イベント送信
      this.$gtm.sendEprintEvent('paypay_payment_start', {
        payment_method: 'paypay',
        price: this.currentPaymentPrice,
        print_type: this.printType,
        format_id: this.formatid,
        funnel_session_id: this.funnelSessionId
      })

      // PayPayコード取得イベントを発火
      this.$eventHub.$emit('get_paypay_code_eprint')
    },
    eprintAtokakin: function (paymentData) {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      this.eprintProcessingPending = false
      this.eprintPDFSending = true
      // コンビニプリント番号発行中のローディング開始
      this.isEprintProcessing = true
      const pdfStartTime = Date.now()

      // ファネル分析: PDF生成開始イベント（事前決済）
      this.$gtm.sendEprintEvent('pdf_generation_start', {
        payment_method: 'prepaid',
        print_type: this.printType,
        format_id: this.formatid,
        funnel_session_id: this.funnelSessionId
      })

      const formData = this.pdfFormData
      formData.append('filename', this.createFilename('pdf'))
      formData.append('format_id', this.formatid)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('print_type', this.printType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('app_flag', this.$site.appFlag)
      formData.append('font_name', this.selFontStyle4DB)
      formData.append('version', '2')
      formData.append('is_mypage', this.isMypage ? 'true' : 'false')
      // authorize+capture 分離: 与信枠確保済みの PaymentIntent ID を渡す。
      // サーバー側で番号発行に成功したら capture（確定課金）、失敗したら cancel（課金ゼロ）する。
      // 引数 paymentData を最優先（フォールバック経路で lastPaymentData が非同期未設定でも確実に渡すため）。
      const paymentIntentId =
        (paymentData && paymentData.paymentIntentId) ||
        (this.lastPaymentData && this.lastPaymentData.stripePaymentIntentId) ||
        null
      if (paymentIntentId) {
        formData.append('payment_intent_id', paymentIntentId)
      }
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.pdfEprintAtokakin, formData, { timeout: 60000 })
        .then(function (response) {
          // コンビニプリント処理完了
          app.isEprintProcessing = false

          if (response.data.result === 'success') {
            // ファネル分析: PDF生成完了イベント（事前決済）
            app.$gtm.sendEprintEvent('pdf_generation_complete', {
              payment_method: 'prepaid',
              duration_ms: Date.now() - pdfStartTime,
              print_type: app.printType,
              format_id: app.formatid,
              funnel_session_id: app.funnelSessionId
            })
            app.resultname = 'なし'
            app.eprintResultCode = '200'
            app.eprintContentsCode = response.data.contents_code
            app.expirationDate = response.data.expiration_date
            // 事前決済の場合、自動的に「ローソン・ファミマなど」を選択
            if (app.isPrePayment) {
              app.selectedStore = 'others'
            }

            // ファネル分析: コンテンツ番号発行成功イベント送信
            app.$gtm.sendEprintEvent('code_issued', {
              contents_code: response.data.contents_code,
              expiration_date: response.data.expiration_date,
              payment_method: 'prepaid',
              price: app.currentPaymentPrice,
              print_type: app.printType,
              format_id: app.formatid,
              funnel_session_id: app.funnelSessionId
            })
          } else if (response.data.result === 'already_issued' && response.data.contents_code) {
            // 二重購入ガード: 直近に発行済みの番号がある（今回の与信は解放済み＝課金なし）。
            // 既存番号を成功時と同じUIで表示する。返金フローには流さない（課金が無いため）
            app.resultname = 'なし'
            app.eprintResultCode = '200'
            app.eprintContentsCode = response.data.contents_code
            app.expirationDate = response.data.expiration_date
            if (app.isPrePayment) {
              app.selectedStore = 'others'
            }
            app.$message({
              duration: 0,
              showClose: true,
              message: response.data.message || '発行済みのコンテンツ番号を表示しています。今回のお支払いは課金されていません。',
              type: 'warning'
            })
            app.$gtm.sendEprintEvent('duplicate_purchase_blocked', {
              block_type: 'already_issued',
              payment_method: 'prepaid',
              print_type: app.printType,
              format_id: app.formatid,
              funnel_session_id: app.funnelSessionId
            })
          } else if (response.data.result === 'processing') {
            // 二重購入ガード: 決済処理がサーバ側で進行中（今回分の課金は発生していない）。
            // 番号はマイページとメールに届くため、再購入させないようボタンは無効のままにする
            app.eprintProcessingPending = true
            app.$message({
              duration: 0,
              showClose: true,
              message: response.data.message || '決済処理が続いています。番号は数分以内にマイページとメールでお知らせします。再度購入しないでください。',
              type: 'warning'
            })
            app.$gtm.sendEprintEvent('duplicate_purchase_blocked', {
              block_type: 'processing',
              payment_method: 'prepaid',
              print_type: app.printType,
              format_id: app.formatid,
              funnel_session_id: app.funnelSessionId
            })
          } else {
            // コンビニプリント番号発行に失敗した場合、事前決済なら返金処理を実行
            if (app.isPrePayment && app.lastPaymentData) {
              console.log('コンビニプリント番号発行失敗 - 返金処理を開始します')
              app.handleEprintFailureRefund(response.data.message || 'コンビニプリント番号の発行に失敗しました')
              return
            }

            if (response.data.message === '不正なページ数です') {
              app.$message({
                duration: 0,
                showClose: true,
                dangerouslyUseHTMLString: true,
                message: `送信失敗しました。${response.data.message}<br><br>ふりがなが長すぎるなどの理由により、フォーマットが崩れている可能性があります。<br>入力内容を確認し、修正してください。<br>ブラウザのキャッシュを削除するか、更新してください。`,
                type: 'error'
              })
            } else if (response.data.message === 'バージョンエラーです。ブラウザのキャッシュを削除するか、更新してください。') {
              app.$message({
                duration: 0,
                showClose: true,
                dangerouslyUseHTMLString: true,
                message: `送信失敗しました。${response.data.message}<br><br>今見ている画面が古い可能性があります。<br>ブラウザのキャッシュを削除するか、更新してください。`,
                type: 'error'
              })
            } else {
              app.$message({
                duration: 0,
                showClose: true,
                message: `送信失敗しました。${response.data.message}`,
                type: 'error'
              })
            }
          }
        })
        .catch(function (error) {
          // コンビニプリント処理エラー
          app.isEprintProcessing = false

          // ファネル分析: PDF生成エラーイベント（事前決済）
          app.$gtm.sendEprintEvent('pdf_generation_error', {
            error_message: String(error),
            payment_method: 'prepaid',
            duration_ms: Date.now() - pdfStartTime,
            print_type: app.printType,
            format_id: app.formatid,
            funnel_session_id: app.funnelSessionId
          })

          // クレカ後課金でaxiosタイムアウト（60秒）した場合、バックエンドは処理を継続していて
          // capture・番号発行まで完了することがある。ここで「失敗・再試行」を案内すると
          // ユーザーが再購入して二重課金になる（2026-07-09 実発生）ため、
          // 「処理継続中」の案内に切り替えて再購入を止める。番号はマイページとメールに届く
          const isTimeout = !!(error && (error.code === 'ECONNABORTED' || /timeout/i.test(error.message || '')))
          if (paymentIntentId && isTimeout) {
            app.eprintProcessingPending = true
            app.$message({
              duration: 0,
              showClose: true,
              message: '決済処理が続いています。番号は数分以内にマイページとメールでお知らせします。再度購入しないでください。',
              type: 'warning'
            })
          } else {
            app.$message({
              duration: 0,
              showClose: true,
              message: '送信失敗しました。しばらくしてから再度お試しください',
              type: 'error'
            })
          }
          console.error(error)
          app.$gtm.sendError('pdf eprint api', `send pdf eprint-api failed ${error}`)
        }).finally(function () {
          app.eprintPDFSending = false
          app.isCreditCardProcessing = false
          if (app.eprintProcessingPending) {
            // 決済処理がサーバ側で継続中の可能性: 再購入による二重課金を防ぐため購入ボタンは無効のまま
            app.isSevenElevenButtonDisabled = true
            const selector = app.$refs['small-payment-method-selector']
            if (selector) {
              selector.isConvinienceButtonDisabled = true
              selector.isCardButtonDisabled = true
              selector.isPaypayButtonDisabled = true
            }
          } else {
            app.eprintPdfEnabled = true
            app.isSevenElevenButtonDisabled = false
            app.$refs['small-payment-method-selector'] && (app.$refs['small-payment-method-selector'].isConvinienceButtonDisabled = false)
          }
        })
    },
    savePaypayEprintTempData: function (merchant_payment_id, url) {
      // PayPay決済前の一時データ保存
      const app = this
      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('payment_cost', this.currentPaymentPrice)
      formData.append('print_type', this.printType)
      formData.append('format_id', this.formatid)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('app_html', this.previewHtml)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('app_flag', this.$site.appFlag)
      formData.append('font_name', this.selFontStyle4DB)
      formData.append('version', '2')
      formData.append('merchant_payment_id', merchant_payment_id)

      // 決済ログを保存（pending状態）
      this.savePaymentLog('paypay', this.currentPaymentPrice, 'pending')
        .then(function (logResult) {
          console.log('PayPay Eprint 決済ログ保存成功:', logResult)

          // PayPay一時データ保存
          return app.$axios.post(app.$varuna.endPoints.savePaypayEprintTempdata, formData, { timeout: 60000 })
        })
        .then(function (response) {
          if (response.data.status === 'success') {
            app.$message({
              message: 'PayPayページに遷移します',
              type: 'success'
            })

            // PayPay決済IDとデータをローカルストレージに保存
            localStorage.setItem('paypay_eprint_merchant_id', merchant_payment_id)
            localStorage.setItem('paypay_eprint_data', JSON.stringify({
              printType: app.printType,
              formatId: app.formatid,
              fileName: formData.get('filename'),
              paymentCost: app.currentPaymentPrice,
              previewHtml: app.previewHtml,
              fontName: app.selFontStyle4DB,
              merchantPaymentId: merchant_payment_id
            }))

            console.log('PayPay Eprint 決済開始:', {
              merchant_payment_id,
              redirect_url: url,
              payment_cost: app.currentPaymentPrice
            })

            // 直接遷移ではなく、注意モーダルを表示
            app.paypayEprintUrl = url
            app.merchantPaymentId = merchant_payment_id
            app.$modal.show('open_paypay_eprint_modal')
          } else {
            // 処理順入れ替え: ここでの失敗は「課金前の印刷データ準備（コンテンツ番号発行）失敗」。
            // まだ課金されていないため、PayPayへは遷移させない（モーダルを出さない）。
            app.$message({
              message: response.data.message || '印刷データの準備に失敗しました。お手数ですが、もう一度お試しください。',
              type: 'error'
            })
            app.updatePaymentLogStatus('failed')
          }
        })
        .catch(function (error) {
          app.$message({
            message: '印刷データの準備に失敗しました。お手数ですが、もう一度お試しください。',
            type: 'error'
          })
          console.error(error)
          app.updatePaymentLogStatus('failed')
        })
    },
    openPayPayEprintSite: function () {
      // PayPay決済サイトに遷移
      const app = this
      // イベント発火でPayPay決済完了処理を準備
      app.$eventHub.$emit('complate_paypay_eprint', app.merchantPaymentId)
      // PayPay決済サイトに遷移
      window.location.href = this.paypayEprintUrl
    },
    completePaypayEprint: function (merchant_payment_id) {
      // PayPay決済完了処理
      console.log('=== completePaypayEprint 開始 ===')
      console.log('merchant_payment_id:', merchant_payment_id)

      const app = this
      const formData = new FormData()
      formData.append('merchant_payment_id', merchant_payment_id)
      formData.append('version', '2')

      // ローカルストレージからpaypay_eprint_dataを取得して判定用データを追加
      const eprintData = localStorage.getItem('paypay_eprint_data')
      if (eprintData) {
        try {
          const data = JSON.parse(eprintData)
          console.log('ローカルストレージのpaypay_eprint_data:', data)

          // 判定用データをformDataに追加
          if (data.fontName) {
            formData.append('font_name', data.fontName)
          }
          if (data.formatId) {
            formData.append('format_id', data.formatId)
          }
          if (data.printType) {
            formData.append('print_type', data.printType)
          }
          if (data.merchantPaymentId) {
            formData.append('merchant_payment_id_check', data.merchantPaymentId)
          }
        } catch (e) {
          console.error('ローカルストレージのpaypay_eprint_data解析エラー:', e)
        }
      }

      console.log('送信するformData:')
      for (const [key, value] of formData.entries()) {
        console.log(`${key}: ${value}`)
      }

      console.log('PayPay決済完了確認API呼び出し:', this.$varuna.endPoints.paypayComplateEprint)
      // PayPay決済確認中のローディング開始
      this.isPaypayProcessing = true
      this.$axios.post(this.$varuna.endPoints.paypayComplateEprint, formData, { timeout: 60000 })
        .then(function (response) {
          console.log('PayPay決済完了確認レスポンス:', response)
          console.log('response.data:', response.data)
          console.log('response.data.status:', response.data.status)

          if (response.data.status === 'success') {
            // PayPay決済とコンビニ印刷処理が完了（バックエンド一気通貫処理）
            app.isPaypayProcessing = false

            console.log('PayPay決済とコンビニ印刷処理が完了しました（一気通貫処理）')

            // バックエンドから返されたデータを使用
            const responseData = response.data.data

            if (responseData && responseData.contents_code) {
              // 決済データを保存（返金処理用）
              app.lastPaymentData = {
                paymentType: 'paypay',
                paymentCost: responseData.payment_cost,
                printType: responseData.print_type,
                formatId: responseData.format_id,
                transactionId: responseData.merchant_payment_id,
                paymentHistoryId: responseData.payment_history_id,
                timestamp: new Date().toISOString()
              }

              console.log('決済データ保存完了:', app.lastPaymentData)

              // コンビニ印刷結果を直接表示（バックエンドで処理済み）
              app.resultname = 'なし'
              app.eprintResultCode = '200'
              app.eprintContentsCode = responseData.contents_code
              app.expirationDate = responseData.expiration_date
              app.isPrePayment = true

              // 事前決済の場合、自動的に「ローソン・ファミマなど」を選択
              app.selectedStore = 'lawson'

              // ファネル分析: PayPay決済完了成功イベント送信
              app.$gtm.sendEprintEvent('paypay_payment_complete', {
                payment_method: 'paypay',
                transaction_id: responseData.merchant_payment_id,
                contents_code: responseData.contents_code,
                expiration_date: responseData.expiration_date,
                price: responseData.payment_cost,
                print_type: responseData.print_type,
                format_id: responseData.format_id,
                funnel_session_id: app.funnelSessionId
              })

              // GA4 Eコマースイベント送信（PayPay決済）
              app.$gtm.sendEprintPurchase({
                transaction_id: 'eprint_paypay_' + responseData.merchant_payment_id,
                value: responseData.payment_cost,
                print_type: responseData.print_type,
                product_name: app.$gtm.getPrintTypeLabel(responseData.print_type)
              })

              // ファネル分析: コンテンツ番号発行成功イベント送信（PayPayフロー）
              app.$gtm.sendEprintEvent('code_issued', {
                contents_code: responseData.contents_code,
                expiration_date: responseData.expiration_date,
                payment_method: 'prepaid',
                price: responseData.payment_cost,
                print_type: responseData.print_type,
                format_id: responseData.format_id,
                funnel_session_id: app.funnelSessionId
              })

              // PayPay決済完了メッセージ
              app.$message({
                message: 'PayPay決済とコンビニ印刷処理が完了しました',
                type: 'success',
                duration: 3000
              })

              // ダイアログが表示されていない場合は表示
              app.$nextTick(() => {
                const modalElement = document.querySelector('.v--modal[data-modal="eprint-dialog"]')
                if (!modalElement || modalElement.style.display === 'none') {
                  console.log('コンテンツ番号取得後、ダイアログを表示')
                  // PayPay決済完了後は、保存されたフォーマットIDでサイズ選択肢を再設定
                  const savedData = JSON.parse(localStorage.getItem('paypay_eprint_data') || '{}')
                  if (savedData.formatId) {
                    console.log('PayPay決済完了後、フォーマットIDでサイズ選択肢を再設定:', savedData.formatId)
                    // previewHtmlをオブジェクト形式で渡す（openDialogメソッドの期待する形式）
                    const htmlObj = { innerHTML: savedData.previewHtml || '' }
                    app.openDialog(savedData.formatId, htmlObj, savedData.fontName || '')
                  } else {
                    app.$modal.show('eprint-dialog')
                  }
                }
              })
            } else {
              // コンテンツ番号がない場合（エラー）
              const errorMsg = response.data.message || 'PayPay決済は完了しましたが、コンテンツ番号の取得に失敗しました。返金処理を確認中です。'

              // ファネル分析: PayPay決済後のコンテンツ番号発行失敗イベント送信
              app.$gtm.sendEprintEvent('paypay_code_issue_failed', {
                payment_method: 'paypay',
                error_message: errorMsg,
                price: app.currentPaymentPrice,
                print_type: app.printType,
                format_id: app.formatid,
                funnel_session_id: app.funnelSessionId
              })

              app.$message({
                message: errorMsg,
                type: 'warning',
                duration: 0,
                showClose: true
              })

              // エラーの場合はポップアップを閉じる
              app.$modal.hide('eprint-dialog')
            }

            // LocalStorageをクリア
            localStorage.removeItem('paypay_eprint_data')
            localStorage.removeItem('paypay_eprint_merchant_id')

            console.log('PayPay決済完了処理終了（一気通貫処理）')
          } else {
            console.log('PayPay決済完了確認 - statusがsuccess以外:', response.data.status)
            // PayPay決済確認失敗
            app.isPaypayProcessing = false

            // より詳細なエラーメッセージを表示
            const errorMessage = response.data.message || 'PayPay決済が完了していません'

            // ファネル分析: PayPay決済確認失敗イベント送信
            app.$gtm.sendEprintEvent('paypay_payment_failed', {
              payment_method: 'paypay',
              error_status: response.data.status,
              error_message: errorMessage,
              price: app.currentPaymentPrice,
              print_type: app.printType,
              format_id: app.formatid,
              funnel_session_id: app.funnelSessionId
            })

            app.$message({
              message: errorMessage,
              type: 'error',
              duration: 0,
              showClose: true
            })

            // エラーの場合はポップアップを閉じる
            app.$modal.hide('eprint-dialog')

            // 決済ログの状態を更新
            app.updatePaymentLogStatus('failed')

            // 決済未完了の場合、ダイアログの状態をリセット
            app.eprintResultCode = '100'
            app.isPrePayment = false
          }
        })
        .catch(function (error) {
          console.error('PayPay決済完了確認エラー:', error)
          // PayPay決済確認エラー
          app.isPaypayProcessing = false

          // ネットワークエラーやタイムアウトの場合の詳細なエラーメッセージ
          let errorMessage = 'PayPay決済の確認に失敗しました'
          if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
            errorMessage = 'PayPay決済の確認がタイムアウトしました。しばらく待ってから再度お試しください。'
          } else if (error.response && error.response.status >= 500) {
            errorMessage = 'サーバーエラーが発生しました。しばらく待ってから再度お試しください。'
          }

          app.$message({
            message: errorMessage,
            type: 'error',
            duration: 0,
            showClose: true
          })

          // エラーの場合はポップアップを閉じる
          app.$modal.hide('eprint-dialog')

          // 決済未完了の場合、ダイアログの状態をリセット
          app.eprintResultCode = '100'
          app.isPrePayment = false
        })
    },
    savePaymentLog: function (paymentType, paymentCost, paymentStatus, transactionId = '') {
      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('print_type', this.printType)
      formData.append('format_id', this.formatid)
      formData.append('payment_type', paymentType)
      formData.append('payment_cost', paymentCost)
      formData.append('payment_status', paymentStatus)
      if (transactionId) {
        formData.append('detail', `取引番号: ${transactionId}`)
      }

      return this.$axios.post(this.$varuna.endPoints.logConveniencePayment, formData, { timeout: 30000 })
    },
    savePaymentLogAndGetId: async function (paymentType, paymentCost, paymentStatus, detailOrTransactionId = '') {
      console.log('=== savePaymentLogAndGetId 開始 ===')
      console.log('パラメータ:', { paymentType, paymentCost, paymentStatus, detailOrTransactionId })

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('print_type', this.printType)
      formData.append('format_id', this.formatid)
      formData.append('payment_type', paymentType)
      formData.append('payment_cost', paymentCost)
      // boolean値を文字列に変換
      formData.append('payment_status', paymentStatus === true ? 'true' : 'false')
      if (detailOrTransactionId) {
        // JSON文字列の場合はそのまま、それ以外は取引番号として扱う
        if (detailOrTransactionId.startsWith('{')) {
          formData.append('detail', detailOrTransactionId)
        } else {
          formData.append('detail', `取引番号: ${detailOrTransactionId}`)
        }
      }

      // デバッグ用：送信するパラメータをログ出力
      console.log('送信パラメータ:', {
        uuid: this.$firebase.user.uid,
        print_type: this.printType,
        format_id: this.formatid,
        payment_type: paymentType,
        payment_cost: paymentCost,
        payment_status: paymentStatus,
        detail: detailOrTransactionId || ''
      })

      try {
        const response = await this.$axios.post(this.$varuna.endPoints.logConveniencePayment, formData, { timeout: 30000 })
        console.log('決済ログ保存レスポンス:', response.data)

        if (response.data.result === 'success' && response.data.payment_history_id) {
          console.log('決済ログ保存成功、payment_history_id:', response.data.payment_history_id)
          return response.data.payment_history_id
        } else {
          console.error('決済ログ保存失敗:', response.data)
          throw new Error(`決済ログ保存に失敗しました: ${response.data.message || '不明なエラー'}`)
        }
      } catch (error) {
        console.error('決済ログ保存エラー:', error)
        if (error.response && error.response.data) {
          console.error('エラーレスポンス:', error.response.data)
        }
        throw error
      }
    },
    updatePaymentLogStatus: function (status, transactionId = '') {
      // 決済ログの状態更新（必要に応じて実装）
      console.log('決済ログ状態更新:', status, transactionId)
      if (transactionId) {
        this.savePaymentLog('paypay', this.currentPaymentPrice, status, transactionId)
      }
    },
    checkPaypayEprintReturn: function () {
      console.log('=== checkPaypayEprintReturn 開始 ===')
      // PayPay決済後のリダイレクト確認処理
      const urlParams = new URLSearchParams(window.location.search)
      const paypayReturn = urlParams.get('paypay_eprint_return')
      const merchantIdFromUrl = urlParams.get('merchant_payment_id')
      const merchantIdFromStorage = localStorage.getItem('paypay_eprint_merchant_id')

      console.log('paypayReturn:', paypayReturn)
      console.log('merchantIdFromUrl:', merchantIdFromUrl)
      console.log('merchantIdFromStorage:', merchantIdFromStorage)

      // PayPay決済のリターンでない場合は、古いPayPayデータをクリーンアップ
      if (paypayReturn !== '1') {
        console.log('PayPay決済のリターンではありません。')

        // 古いPayPayデータが残っている場合はクリア
        if (merchantIdFromStorage) {
          console.log('古いPayPay Eprintデータをクリアします:', merchantIdFromStorage)
          localStorage.removeItem('paypay_eprint_merchant_id')
          localStorage.removeItem('paypay_eprint_data')
        }

        console.log('処理を終了します。')
        return
      }

      // merchant_payment_idが存在しない場合も何もしない
      if (!merchantIdFromUrl && !merchantIdFromStorage) {
        return
      }

      console.log('PayPay Eprint 決済完了確認開始:', merchantIdFromUrl || merchantIdFromStorage)

      // クッキーからpayment_history_idを復元（リダイレクト後の返金処理用）
      const paymentHistoryId = this.$cookies.get('paypay_payment_history_id')
      if (paymentHistoryId) {
        console.log('PayPay決済のpayment_history_idをクッキーから復元:', paymentHistoryId)
        // 一時的にlastPaymentDataを設定（返金処理で使用される可能性があるため）
        this.lastPaymentData = {
          paymentType: 'paypay',
          paymentHistoryId,
          timestamp: new Date().toISOString()
        }
      }

      // URLのクエリパラメータをクリア
      const cleanUrl = window.location.pathname + window.location.hash
      window.history.replaceState({}, document.title, cleanUrl)

      // PayPay決済データがある場合はEprintDialogを即座に表示
      const eprintData = localStorage.getItem('paypay_eprint_data')
      if (eprintData) {
        try {
          const data = JSON.parse(eprintData)
          // ダイアログを開く（データを復元）
          this.restoreEprintDialogFromPaypay(data)
        } catch (e) {
          console.error('PayPay Eprint データの復元に失敗:', e)
          // データ復元に失敗してもダイアログを表示
          this.$modal.show('eprint-dialog')
        }
      } else {
        // PayPay決済完了リダイレクトだが、データがない場合も即座にダイアログを表示
        console.log('PayPay決済完了リダイレクトを検出、ダイアログを即座に表示')
        // PayPay決済確認中のローディング開始
        this.isPaypayProcessing = true
        this.$modal.show('eprint-dialog')
      }

      // 決済完了処理を実行
      this.completePaypayEprint(merchantIdFromUrl || merchantIdFromStorage)
    },
    restoreEprintDialogFromPaypay: function (eprintData) {
      // PayPay決済後にEprintDialogの状態を復元
      console.log('Eprint Dialog状態復元:', eprintData)

      // ダイアログの状態を復元
      this.printType = eprintData.printType
      this.formatid = eprintData.formatId
      this.selFontStyle4DB = eprintData.fontName
      this.previewHtml = eprintData.previewHtml

      // PayPay決済完了後は結果コードを初期化（コンビニプリント選択画面ではなく、完了確認画面を表示）
      this.eprintResultCode = '100'

      // PayPay決済確認中のローディング状態を開始
      this.isPaypayProcessing = true

      // ダイアログを即座に開く
      console.log('PayPay決済完了後のダイアログ表示を実行')
      this.$modal.show('eprint-dialog')

      // Vue.jsの更新サイクルを待って確実に表示されるようにする
      this.$nextTick(() => {
        console.log('nextTick後のダイアログ表示確認')
        // ダイアログが表示されていない場合は再試行
        const modalElement = document.querySelector('.v--modal[data-modal="eprint-dialog"]')
        if (!modalElement || !modalElement.style.display || modalElement.style.display === 'none') {
          console.log('ダイアログが表示されていません。再表示を試行します。')
          this.$modal.show('eprint-dialog')
        }
      })
    },
    handleGetPaypayCodeEprint: function () {
      // PayPayコード取得処理（エンドポイントを新しいコンビニ印刷専用エンドポイントに変更）
      const app = this
      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('payment_cost', this.currentPaymentPrice)
      formData.append('print_type', this.printType)
      formData.append('format_id', this.formatid)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('app_html', this.previewHtml)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('app_flag', this.$site.appFlag)
      formData.append('font_name', this.selFontStyle4DB)
      formData.append('version', '2')
      formData.append('redirect_url', window.location.href)

      this.$axios.post(this.$varuna.endPoints.getPaypaycodeEprint, formData, { timeout: 60000 })
        .then(function (response) {
          console.log('PayPay Eprint コード取得成功:', response)
          console.log('PayPay Eprint コード取得成功:', response.data)
          if (response.data.status === 'success' && response.data.data && response.data.data.url) {
            // ファネル分析: PayPayコード取得成功イベント送信
            app.$gtm.sendEprintEvent('paypay_code_received', {
              payment_method: 'paypay',
              merchant_payment_id: response.data.merchant_payment_id,
              price: app.currentPaymentPrice,
              print_type: app.printType,
              format_id: app.formatid,
              funnel_session_id: app.funnelSessionId
            })

            // PayPay一時データ保存
            app.$eventHub.$emit('save_paypay_eprint_tempdata', response.data.merchant_payment_id, response.data.data.url)
          } else {
            // ファネル分析: PayPayコード取得失敗イベント送信
            app.$gtm.sendEprintEvent('paypay_code_error', {
              payment_method: 'paypay',
              error_message: 'PayPay決済コードの取得に失敗しました',
              price: app.currentPaymentPrice,
              print_type: app.printType,
              format_id: app.formatid,
              funnel_session_id: app.funnelSessionId
            })

            app.$message({
              message: 'PayPay決済コードの取得に失敗しました',
              type: 'error'
            })
          }
        })
        .catch(function (error) {
          console.error('PayPay決済コード取得エラー:', error)

          let errorMessage = 'PayPay決済コードの取得に失敗しました'
          let errorCode = 'unknown'

          // より詳細なエラーメッセージを表示
          if (error.response) {
            // サーバーからのエラーレスポンス
            errorCode = 'server_' + error.response.status
            if (error.response.status >= 500) {
              errorMessage = 'サーバーエラーが発生しました。しばらく待ってから再度お試しください。'
            } else if (error.response.status === 404) {
              errorMessage = 'PayPay決済サービスが利用できません。'
            } else if (error.response.data && error.response.data.message) {
              errorMessage = error.response.data.message
            }
          } else if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
            errorCode = 'timeout'
            errorMessage = 'PayPay決済サーバーとの通信がタイムアウトしました。しばらく待ってから再度お試しください。'
          } else if (error.code === 'NETWORK_ERROR' || error.message.includes('Network Error')) {
            errorCode = 'network_error'
            errorMessage = 'ネットワークエラーが発生しました。インターネット接続を確認してください。'
          }

          // ファネル分析: PayPayコード取得エラーイベント送信
          app.$gtm.sendEprintEvent('paypay_code_error', {
            payment_method: 'paypay',
            error_code: errorCode,
            error_message: errorMessage,
            price: app.currentPaymentPrice,
            print_type: app.printType,
            format_id: app.formatid,
            funnel_session_id: app.funnelSessionId
          })

          app.$message({
            message: errorMessage,
            type: 'error',
            duration: 0,
            showClose: true
          })
        })
    },
    handleEprintFailureRefund: async function (errorMessage) {
      console.log('=== 返金処理開始 ===')
      console.log('エラーメッセージ:', errorMessage)
      console.log('決済データ:', this.lastPaymentData)

      if (!this.lastPaymentData) {
        console.error('決済データが見つかりません')
        this.$message({
          message: 'コンビニプリント番号の発行に失敗しました。サポートが必要な場合は、お問い合わせください。',
          type: 'error',
          duration: 0,
          showClose: true
        })
        return
      }

      // 返金処理中のローディング開始
      this.isRefundProcessing = true

      // ファネル分析: 返金処理開始イベント送信
      this.$gtm.sendEprintEvent('refund_initiated', {
        payment_method: this.lastPaymentData.paymentType,
        refund_reason: errorMessage,
        price: this.lastPaymentData.paymentCost,
        print_type: this.lastPaymentData.printType,
        format_id: this.lastPaymentData.formatId,
        payment_history_id: this.lastPaymentData.paymentHistoryId || null,
        funnel_session_id: this.funnelSessionId
      })

      try {
        const formData = new FormData()
        formData.append('uuid', this.$firebase.user.uid)
        formData.append('refund_reason', `コンビニプリント処理失敗: ${errorMessage}`)

        // payment_history_idがある場合はそれを使用（推奨）
        if (this.lastPaymentData.paymentHistoryId) {
          formData.append('payment_history_id', this.lastPaymentData.paymentHistoryId)
          console.log('payment_history_idを使用した返金API呼び出し開始:', this.lastPaymentData.paymentHistoryId)
        } else {
          // 従来の方式（フォールバック）
          formData.append('format_id', this.lastPaymentData.formatId)
          formData.append('print_type', this.lastPaymentData.printType)
          formData.append('payment_cost', this.lastPaymentData.paymentCost)
          console.log('従来の方式で返金API呼び出し開始')
        }

        const response = await this.$axios.post(this.$varuna.endPoints.eprintRefund, formData, { timeout: 60000 })

        console.log('返金API応答:', response.data)

        if (response.data.result === 'success') {
          // ファネル分析: 返金成功イベント送信
          this.$gtm.sendEprintEvent('refund_complete', {
            payment_method: this.lastPaymentData.paymentType,
            refund_amount: this.lastPaymentData.paymentCost,
            print_type: this.lastPaymentData.printType,
            format_id: this.lastPaymentData.formatId,
            funnel_session_id: this.funnelSessionId
          })

          // 返金成功
          this.$message({
            message: 'コンビニプリント番号の発行に失敗したため、返金処理を完了しました。',
            type: 'warning',
            duration: 0,
            showClose: true
          })

          // 決済状態をリセット
          this.isPrePayment = false
          this.lastPaymentData = null
          this.eprintResultCode = '100'

          // PayPay決済の場合、クッキーもクリア
          if (this.lastPaymentData && this.lastPaymentData.paymentType === 'paypay') {
            this.$cookies.remove('paypay_payment_history_id')
            console.log('返金完了後、PayPay payment_history_idクッキーをクリア')
          }
        } else if (response.data.result === 'manual_required') {
          // ファネル分析: 手動返金必要イベント送信
          this.$gtm.sendEprintEvent('refund_manual_required', {
            payment_method: this.lastPaymentData.paymentType,
            refund_amount: this.lastPaymentData.paymentCost,
            print_type: this.lastPaymentData.printType,
            format_id: this.lastPaymentData.formatId,
            funnel_session_id: this.funnelSessionId
          })

          // 手動返金が必要
          this.$message({
            message: 'コンビニプリント番号の発行に失敗しました。サポートが必要な場合は、お問い合わせください。',
            type: 'error',
            duration: 0,
            showClose: true
          })
        } else {
          // ファネル分析: 返金失敗イベント送信
          this.$gtm.sendEprintEvent('refund_failed', {
            payment_method: this.lastPaymentData.paymentType,
            error_message: response.data.message || '返金処理に失敗しました',
            refund_amount: this.lastPaymentData.paymentCost,
            print_type: this.lastPaymentData.printType,
            format_id: this.lastPaymentData.formatId,
            funnel_session_id: this.funnelSessionId
          })

          // 返金失敗
          this.$message({
            message: 'コンビニプリント番号の発行に失敗しました。サポートが必要な場合は、お問い合わせください。',
            type: 'error',
            duration: 0,
            showClose: true
          })
        }
      } catch (error) {
        console.error('返金処理エラー:', error)

        // ファネル分析: 返金処理エラーイベント送信
        this.$gtm.sendEprintEvent('refund_error', {
          payment_method: this.lastPaymentData ? this.lastPaymentData.paymentType : 'unknown',
          error_message: error.message || '返金処理中にエラーが発生しました',
          error_code: error.response ? error.response.status : 'network_error',
          funnel_session_id: this.funnelSessionId
        })

        this.$message({
          message: 'コンビニプリント番号の発行に失敗しました。サポートが必要な場合は、お問い合わせください。',
          type: 'error',
          duration: 0,
          showClose: true
        })
      } finally {
        // 返金処理中のローディング終了
        this.isRefundProcessing = false
      }
    },

    // ========== マップ関連メソッド ==========

    // Google Maps APIを初期化（動的スクリプトタグ方式）
    initGoogleMaps: function () {
      const self = this
      if (self.googleMapsLoaded) return Promise.resolve()
      if (window.google && window.google.maps) {
        self.googleMapsLoaded = true
        return Promise.resolve()
      }

      return new Promise(function (resolve, reject) {
        // 既にスクリプトが読み込み中かチェック
        if (document.querySelector('script[src*="maps.googleapis.com"]')) {
          var checkInterval = setInterval(function () {
            if (window.google && window.google.maps) {
              clearInterval(checkInterval)
              self.googleMapsLoaded = true
              resolve()
            }
          }, 100)
          // タイムアウト処理（15秒）
          setTimeout(function () {
            clearInterval(checkInterval)
            if (!self.googleMapsLoaded) {
              self.mapError = 'マップの読み込みがタイムアウトしました。'
              reject(new Error('Google Maps load timeout'))
            }
          }, 15000)
          return
        }

        const script = document.createElement('script')
        script.src = 'https://maps.googleapis.com/maps/api/js?key=' +
          process.env.VUE_APP_GOOGLE_MAPS_API_KEY + '&libraries=places'
        script.async = true
        script.defer = true
        script.onload = function () {
          self.googleMapsLoaded = true
          resolve()
        }
        script.onerror = function () {
          self.mapError = 'マップの読み込みに失敗しました。ページを再読み込みしてください。'
          reject(new Error('Google Maps script load failed'))
        }
        document.head.appendChild(script)
      })
    },

    // マップを指定座標で表示
    showMapAtLocation (lat, lng) {
      this.showMap = true
      this.mapError = ''

      const self = this
      this.$nextTick(function () {
        const mapContainer = self.$refs.konbiniMap
        if (!mapContainer) {
          console.error('Map container not found')
          return
        }

        const center = { lat, lng }

        if (!self.googleMap) {
          self.googleMap = new google.maps.Map(mapContainer, {
            center,
            zoom: 15,
            disableDefaultUI: true
          })
          self.infoWindow = new google.maps.InfoWindow()
          self.placesService = new google.maps.places.PlacesService(self.googleMap)
        } else {
          self.googleMap.setCenter(center)
          self.googleMap.setZoom(15)
        }

        // 現在地マーカーを更新
        if (self.currentLocationMarker) {
          self.currentLocationMarker.setMap(null)
        }
        self.currentLocationMarker = new google.maps.Marker({
          position: center,
          map: self.googleMap,
          icon: {
            path: google.maps.SymbolPath.CIRCLE,
            scale: 8,
            fillColor: '#4285F4',
            fillOpacity: 1,
            strokeColor: '#ffffff',
            strokeWeight: 2
          },
          title: '検索地点'
        })

        // 周辺コンビニを検索
        self.searchNearbyKonbini(center)
      })
    },

    // HTML特殊文字をエスケープ（XSS対策）
    escapeHtml (str) {
      const div = document.createElement('div')
      div.appendChild(document.createTextNode(str))
      return div.innerHTML
    },

    // 周辺コンビニを検索（Places API）
    searchNearbyKonbini (location) {
      const self = this
      // 既存のマーカーをクリア
      this.storeMarkers.forEach(function (m) { m.setMap(null) })
      this.storeMarkers = []

      const request = {
        location,
        radius: 1000,
        type: 'convenience_store',
        keyword: 'コンビニ'
      }

      this.placesService.nearbySearch(request, function (results, status) {
        if (status === google.maps.places.PlacesServiceStatus.OK && results) {
          results.forEach(function (place) {
            const marker = new google.maps.Marker({
              position: place.geometry.location,
              map: self.googleMap,
              title: place.name
            })

            marker.addListener('click', function () {
              let openStatus = ''
              if (place.opening_hours) {
                openStatus = '<br><span style="color:' + (place.opening_hours.open_now ? 'green' : 'red') + ';">' +
                  (place.opening_hours.open_now ? '営業中' : '営業時間外') + '</span>'
              }
              const content = '<div style="font-size:13px;max-width:200px;">' +
                '<strong>' + self.escapeHtml(place.name) + '</strong><br>' +
                self.escapeHtml(place.vicinity || '') +
                openStatus +
                '<br><a href="https://www.google.com/maps/dir/?api=1&destination=' +
                place.geometry.location.lat() + ',' + place.geometry.location.lng() +
                '" target="_blank" rel="noopener" style="color:#1a73e8;">ルート案内</a>' +
                '</div>'
              self.infoWindow.setContent(content)
              self.infoWindow.open(self.googleMap, marker)
            })

            self.storeMarkers.push(marker)
          })

          if (results.length === 0) {
            self.mapError = '周辺にコンビニが見つかりませんでした。マップをズームアウトしてみてください。'
          }
        } else if (status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
          self.mapError = '周辺にコンビニが見つかりませんでした。'
        } else {
          console.error('Places search failed:', status)
          self.mapError = 'コンビニの検索に失敗しました。'
        }
      })
    },

    // 現在地周辺を検索
    searchNearCurrentLocation: function () {
      const self = this
      self.mapError = ''
      self.isGeolocating = true

      self.initGoogleMaps()
        .then(function () {
          if (!self.googleMapsLoaded) {
            self.isGeolocating = false
            return
          }
          return self.getCurrentPosition()
        })
        .then(function (position) {
          if (!position) return
          self.currentPosition = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          self.showMapAtLocation(self.currentPosition.lat, self.currentPosition.lng)
        })
        .catch(function (error) {
          self.handleGeolocationError(error)
        })
        .then(function () {
          self.isGeolocating = false
        })
    },

    // 履歴書住所周辺を検索
    searchNearResumeAddress: function () {
      const self = this
      if (!self.resumeAddress) {
        self.mapError = '履歴書に住所が入力されていません。'
        return
      }

      self.mapError = ''
      self.isGeocodingAddress = true

      self.initGoogleMaps()
        .then(function () {
          if (!self.googleMapsLoaded) {
            self.isGeocodingAddress = false
            return
          }
          const geocoder = new google.maps.Geocoder()
          geocoder.geocode({ address: self.resumeAddress }, function (results, status) {
            if (status === 'OK' && results && results.length > 0) {
              const location = results[0].geometry.location
              self.showMapAtLocation(location.lat(), location.lng())
            } else {
              self.mapError = '住所から位置を特定できませんでした。'
            }
            self.isGeocodingAddress = false
          })
        })
        .catch(function (error) {
          console.error('Geocoding error:', error)
          self.mapError = '住所の検索に失敗しました。もう一度お試しください。'
          self.isGeocodingAddress = false
        })
    },

    // 現在地に戻る
    recenterToCurrentLocation: function () {
      if (this.currentPosition && this.googleMap) {
        this.googleMap.setCenter(this.currentPosition)
        this.googleMap.setZoom(15)
        this.searchNearbyKonbini(this.currentPosition)
        return
      }
      this.searchNearCurrentLocation()
    },

    // ブラウザ位置情報取得（Promise wrapper）
    getCurrentPosition () {
      return new Promise(function (resolve, reject) {
        if (!navigator.geolocation) {
          reject(new Error('GEOLOCATION_NOT_SUPPORTED'))
          return
        }
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          enableHighAccuracy: false,
          timeout: 10000,
          maximumAge: 300000
        })
      })
    },

    // 位置情報エラー処理
    handleGeolocationError (error) {
      if (error.message === 'GEOLOCATION_NOT_SUPPORTED') {
        this.mapError = 'お使いのブラウザは位置情報に対応していません。'
      } else if (error.code === 1) {
        this.mapError = '位置情報へのアクセスが拒否されました。ブラウザの設定から位置情報を許可してください。'
      } else if (error.code === 2) {
        this.mapError = '位置情報を取得できませんでした。'
      } else if (error.code === 3) {
        this.mapError = '位置情報の取得がタイムアウトしました。もう一度お試しください。'
      } else {
        this.mapError = '位置情報の取得に失敗しました。'
      }
    },

    // マップリソースをクリーンアップ
    cleanupMap () {
      this.storeMarkers.forEach(function (m) { m.setMap(null) })
      this.storeMarkers = []
      if (this.currentLocationMarker) {
        this.currentLocationMarker.setMap(null)
        this.currentLocationMarker = null
      }
      if (this.infoWindow) {
        this.infoWindow.close()
      }
      this.googleMap = null
      this.showMap = false
      this.mapError = ''
    },

    // 現在地周辺のコンビニをマップアプリで開く
    openMapAppNearCurrentLocation: function () {
      const self = this
      self.mapError = ''
      self.isGeolocating = true

      // 既に現在地を取得済みの場合はそのまま使う
      if (self.currentPosition) {
        const url = 'https://www.google.com/maps/search/コンビニ/@' +
          self.currentPosition.lat + ',' + self.currentPosition.lng + ',15z'
        window.open(url, '_blank')
        self.isGeolocating = false
        return
      }

      self.getCurrentPosition()
        .then(function (position) {
          self.currentPosition = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          const url = 'https://www.google.com/maps/search/コンビニ/@' +
            self.currentPosition.lat + ',' + self.currentPosition.lng + ',15z'
          window.open(url, '_blank')
        })
        .catch(function (error) {
          self.handleGeolocationError(error)
        })
        .then(function () {
          self.isGeolocating = false
        })
    },

    // 履歴書住所周辺のコンビニをマップアプリで開く
    openMapAppNearResumeAddress: function () {
      if (!this.resumeAddress) {
        this.mapError = '履歴書に住所が入力されていません。'
        return
      }
      const query = encodeURIComponent('コンビニ ' + this.resumeAddress)
      window.open('https://www.google.com/maps/search/' + query, '_blank')
    }
  },
  computed: {
    currentPaymentPrice () {
      // 統一価格を使用
      return this.eprintPrice
    },
    // 選択中サイズがキャッシュレス決済対応なら PayPay を既定の決済方法にする
    // （SmallPaymentMethodSelector へ渡し、対応サイズ選択時に PayPay を開いた状態にする）
    defaultEprintPaymentMethod () {
      return this.isCashlessSupported({ id: this.printType }) ? 'paypay' : 'convinience'
    },
    // 現在のテンプレート設定を取得
    currentTemplateConfig () {
      return this.templateConfigs[this.printFlag] || this.templateConfigs.basic
    },
    // おすすめオプション
    recommendedOption () {
      const config = this.currentTemplateConfig
      return config.options.find(option => option.id === config.recommended)
    },
    // その他のオプション（おすすめ以外）
    otherOptions () {
      const config = this.currentTemplateConfig
      return config.options.filter(option => option.id !== config.recommended)
    },
    // おすすめオプションがあるかどうか
    hasRecommendedOption () {
      return !!this.recommendedOption
    },
    // その他のオプションがあるかどうか
    hasOtherOptions () {
      return this.otherOptions.length > 0
    },
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.previewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    },
    // QRコード画像のURLを生成（キャッシュバスター付き）
    qrCodeImageSrc () {
      if (this.isPrePayment) {
        // 事前決済時: ローソン・ファミマなど用
        return `${this.$varuna.endPoints.getEprintQrcode}${this.eprintContentsCode}.png?path=p&_=${this.qrCodeCacheBuster}`
      } else if (this.selectedStore === 'seven') {
        // セブンイレブン用
        return `${this.$varuna.endPoints.getEprintQrcode}${this.eprintContentsCode}.png?path=f&_=${this.qrCodeCacheBuster}`
      } else if (this.selectedStore === 'others') {
        // その他コンビニ用
        return `${this.$varuna.endPoints.getEprintQrcode}${this.eprintContentsCode}.png?_=${this.qrCodeCacheBuster}`
      } else {
        // 未選択時のサンプル画像
        return '/static/img/eprint/sample.png'
      }
    }
  },
  beforeMount: function () {
    console.log('=== EprintDialog.beforeMount 開始 ===')
    this.$eventHub.$on('open-eprint-dialog', this.openDialog)
    this.$eventHub.$on('eprint-renew2-PDF2', this.eprintPDF2)
    this.$eventHub.$on('popstate', this.closeDialog)
    this.$eventHub.$on('basic-data-changed', this.dataChanged)
    this.$eventHub.$on('format-data-changed', this.dataChanged)
    this.$eventHub.$on('get_paypay_code_eprint', this.handleGetPaypayCodeEprint)
    this.$eventHub.$on('save_paypay_eprint_tempdata', this.savePaypayEprintTempData)
    this.$eventHub.$on('complate_paypay_eprint', this.completePaypayEprint)
    console.log('=== EprintDialog.beforeMount 完了 ===')
  },
  mounted: function () {
    console.log('=== EprintDialog.mounted 開始 ===')
    console.log('EprintDialog component mounted')
    console.log('this.$el:', this.$el)
    console.log('this.$modal available:', !!this.$modal)

    // PayPay Eprint決済後のリダイレクト確認
    this.checkPaypayEprintReturn()
    console.log('=== EprintDialog.mounted 完了 ===')
  },
  destroyed: function () {
    this.teardownSectionObserver()
    this.$eventHub.$off('open-eprint-dialog', this.openDialog)
    this.$eventHub.$off('eprint-renew2-PDF2', this.eprintPDF2)
    this.$eventHub.$off('popstate', this.closeDialog)
    this.$eventHub.$off('basic-data-changed', this.dataChanged)
    this.$eventHub.$off('format-data-changed', this.dataChanged)
    this.$eventHub.$off('get_paypay_code_eprint', this.handleGetPaypayCodeEprint)
    this.$eventHub.$off('save_paypay_eprint_tempdata', this.savePaypayEprintTempData)
    this.$eventHub.$off('complate_paypay_eprint', this.completePaypayEprint)
  },
  watch: {
    eprintResultCode: function (newVal, oldVal) {
      if (newVal !== '100') {
        this.scrollToTop()
        // 決済完了状態になった場合、事前決済フラグが設定されていることを確認
        // PayPay決済やクレジットカード決済完了後の場合、isPrePaymentをtrueに保持
        if (oldVal === '100' && this.isPrePayment) {
          console.log('決済完了状態に移行、isPrePayment状態を保持:', this.isPrePayment)
        }
        // 決済完了後、自動で現在地を取得してマップ表示
        if (newVal === '200') {
          this.searchNearCurrentLocation()
        }
      } else {
        // 新しい決済フローを開始する場合（'100'に戻る場合）のみリセット
        if (oldVal !== '100') {
          console.log('新しい決済フローを開始、状態をリセット')
          this.isPrePayment = false
          this.selectedStore = null
        }
      }
    },
    printType: function (newVal, oldVal) {
      // printTypeが変更された場合、料金を更新
      console.log('printTypeが変更されました:', newVal)

      // ファネル分析: 印刷タイプ選択イベント送信（初回選択や変更時）
      if (oldVal && newVal !== oldVal && this.funnelSessionId) {
        this.$gtm.sendEprintEvent('print_type_select', {
          print_type: newVal,
          print_type_label: this.$gtm.getPrintTypeLabel(newVal),
          price: this.$gtm.getPrintTypePrice(newVal),
          format_id: this.formatid,
          is_cashless: this.isCashlessSupported({ id: newVal }),
          previous_print_type: oldVal,
          previous_is_cashless: this.isCashlessSupported({ id: oldVal }),
          funnel_session_id: this.funnelSessionId
        })
      }
    },
    // ファネル分析: コンビニ店舗選択イベント
    selectedStore: function (newVal, oldVal) {
      // 店舗が選択された場合（nullからの変更、または店舗間の変更）
      if (newVal && newVal !== oldVal && this.funnelSessionId) {
        // 事前決済で結果コード200の場合は自動選択（PayPay→lawson, クレカ→others）
        const isAutoSelected = this.isPrePayment && this.eprintResultCode === '200' && !oldVal
        this.$gtm.sendEprintEvent('store_select', {
          store_key: newVal,
          store_name: this.$gtm.getStoreLabel(newVal),
          previous_store: oldVal || null,
          format_id: this.formatid,
          print_type: this.printType,
          is_prepayment: this.isPrePayment,
          auto_selected: isAutoSelected,
          funnel_session_id: this.funnelSessionId
        })
      }
    }
  }
}
</script>
